<template>
<div>
  <!--    Breadcrumbs-->
  <breadcrumb style="margin-left: -15px">
    <breadcrumb-item>
      <router-link :to="schedulesLink" exact>Schedules</router-link>
    </breadcrumb-item>
    <breadcrumb-item>
      <span>{{ schedule_name }}</span>
    </breadcrumb-item>
  </breadcrumb>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>
  <base-alert-dialog
    :show="dialog.show"
    :variant="dialog.variant"
    :title="dialog.title"
    :message="dialog.message"
    :show-cancel="dialog.showCancel"
    :confirm-text="dialog.confirmText"
    :confirm-variant="dialog.confirmVariant"
    @confirm="onDialogConfirm"
    @cancel="dialog.show = false"
  />

  <div class="row mt-3 overflow-scroll">
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <div class="row">
          <div class="col">
            <h4  class="card-title">Schedule settings</h4>
          </div>
          <div class="col text-right">
            <div v-if="statusInProgress" class="d-inline-block text-left align-middle mr-2">
              <div class="progress-bar-container">
                <div class="progress-bar-striped"></div>
              </div>
              <small class="text-muted">{{ statusCreationDone ? 'Blocking time slots...' : 'Generating...' }}</small>
            </div>
            <template v-else>
              <badge v-if="schedule.active === 1" type="success">Active</badge>
              <badge v-if="schedule.active === 0" type="danger">Deactivated</badge>
            </template>
            <el-tooltip v-if="statusCreationDone"
                        content="More actions"
                        effect="light"

                        :open-delay="300"
                        placement="top">
              <el-dropdown>
                <base-button
                  link
                  type="primary"
                  size="sm"
                > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                </base-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <a class="dropdown-item" v-if="schedule.active" @click="activateSchedulePrompt('deactivate')" href="#">
                      <i class="tim-icons text-default icon-button-power mr-2"></i> Deactivate schedule
                    </a>
                    <a class="dropdown-item" v-if="!schedule.active" @click="activateSchedulePrompt('activate')" href="#">
                      <i class="tim-icons text-default icon-button-power mr-2"></i> Activate schedule
                    </a>
                    <a class="dropdown-item mt-2" @click="copyScheduleTemplate(schedule, $event)" href="#">
                      <i class="tim-icons text-default icon-single-copy-04 mr-2"></i> Save as new schedule
                    </a>
                    <hr>
                    <a class="dropdown-item" @click="deleteSchedule()" href="#">
                      <i class="tim-icons text-default icon-trash-simple mr-2"></i> Delete schedule
                    </a>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

            </el-tooltip>
          </div>
        </div>
        <info-hint v-if="isAutoblocking" variant="primary" icon="icon-alert-circle-exc" class="mb-3">
          Time slots are still being blocked for this schedule. Saving, activating or deactivating starts blocking again from the beginning.
        </info-hint>
        <div>
          <div class="row">
            <div class="col-lg-3">
              <base-input :error="errs.name" label="Schedule name" type="text" v-model="schedule.name"  placeholder="Name"></base-input>
            </div>
            <div class="col-lg-4" v-if="schedule.type.id === 0">
              <base-input label="Associated events">
                <el-select
                  label="Select game"
                  v-model="schedule.games"
                  v-on:change="j++"
                  class="select-primary"
                  value-key="id"
                  multiple
                >
                  <el-option
                    v-for="(g, i) in games"
                    class="select-primary"
                    :label="g.name"
                    :value="{ name: g.name, id: g.id} "
                    :key="'G' + i"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
<!--            <div class="col-lg-2" v-if="schedule.type.id === 1">-->
<!--              <base-input v-on:change="validateResourceCount()" label="Number of resources (1-100)" v-model="schedule.resource_count">-->
<!--              </base-input>-->
<!--            </div>-->
          </div>

          <div class="row">
            <div class="col-lg-3">
              <label>
                  <span>Schedule duration
                    <el-popover popper-class="otc-pop" v-if="schedule.type.id === 0" trigger="hover"
                                placement="right">

                      <div>
                        <div class="popover-body">When an event is assigned to multiple schedules,
                          priority is given to closed periods over finite schedules,
                          and finite schedules take precedence over recurring schedules.</div>
                      </div>
                      <i slot="reference" style="color: #1d8cf8; vertical-align: middle" class="tim-icons el-icon-info"></i>
                    </el-popover>
                  </span>
              </label>
              <base-input :key="'C' + j">
                <el-select
                  v-model="schedule.duration_type"
                  class="select-primary"
                  value-key="id"
                  v-on:change="j++"
                >
                  <el-option
                    v-for="(f, i) in duration_types"
                    class="select-primary"
                    :label="f.label"
                    :value="{id: f.id, label: f.label}"
                    :key="'F' + i"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input label="Start date" :error="errs.start_date">
                <el-date-picker :editable="false"
                  type="date"
                  placeholder="mm-dd-yyyy"
                  value-format="yyyy-MM-dd"
                  :format="day_of_week + '' + date_format_cal"
                  v-on:change="validateDateRange()"
                  name="date"
                  v-model="schedule.start_date"
                  :picker-options="{ disabledDate: (time) => disabledDates(time, schedule.start_date), firstDayOfWeek: first_day_of_week }"
                >
                </el-date-picker>
              </base-input>
            </div>
            <div v-if="schedule.duration_type.label !== 'Recurring'" class="col-lg-2">
              <base-input label="End date" :error="errs.end_date">
                <el-date-picker :editable="false"
                  type="date"
                  placeholder="mm-dd-yyyy"
                  value-format="yyyy-MM-dd"
                  :format="day_of_week + '' + date_format_cal"
                  v-on:change="validateDateRange()"
                  name="date"
                  v-model="schedule.end_date"
                  :picker-options="{ disabledDate: (time) => disabledDates(time, schedule.end_date), firstDayOfWeek: first_day_of_week }"
                >
                </el-date-picker>
              </base-input>
            </div>
          </div>

          <!--            Time slots-->
          <div v-show="schedule.duration_type.label !== 'Closed period'">
            <hr style="background-color: rgba(255,255,255,0.32)"/>
            <h4  class="card-title">Time slots</h4>
            <div class="row">
              <div class="col">
                <base-button variant="outlined" tone="primary" size="sm" class="mr-2" v-on:click="helpGenerate()">
                  <i class="tim-icons icon-settings-gear-63"></i> Generate slots
                </base-button>
                <base-button variant="outlined" tone="primary" size="sm" class="mr-2" v-on:click="bulkUpdate()">
                  <i class="tim-icons icon-pencil"></i> Bulk update slots
                </base-button>
                <base-button variant="outlined" tone="primary" size="sm" v-on:click="copyDay()">
                  <i class="tim-icons icon-single-copy-04"></i> Copy day
                </base-button>
              </div>
            </div>

            <!--    Generate / bulk update drawer-->
            <base-drawer :show="slotToolsOpen" :title="slotToolsTitle" width="640px" @close="closeSlotTools">
              <template v-if="slotToolsView !== 'main'" #title-prefix>
                <button class="drawer-back-btn" @click="exitToolsPricingView">
                  <i class="tim-icons icon-minimal-left"></i>
                </button>
              </template>

              <template v-if="slotToolsView === 'main' && copy_days">
                <drawer-section title="Copy day" icon="icon-single-copy-04">
                  <base-input label="Copy from">
                    <el-select :value="copySourceDay" class="select-primary" @change="onCopySourceChange">
                      <el-option v-for="(name, i) in dayNames" :key="'CF' + i" class="select-primary" :label="name" :value="i"></el-option>
                    </el-select>
                  </base-input>
                  <label class="text-white d-block">Copy to</label>
                  <div class="mb-3">
                    <base-checkbox v-for="(name, i) in dayNames" :key="'CT' + i" class="mr-2" style="display: inline-block"
                                   v-model="applicableDays[i]" :disabled="i === copySourceDay">{{ name.slice(0, 3) }}</base-checkbox>
                  </div>
                  <label class="text-white d-block">Slots already on these days</label>
                  <segmented-toggle v-model="copyMode" size="sm" :options="copyModeOptions" class="mb-3" />
                  <info-hint v-if="copyMode === 'replace'" variant="primary">
                    Slots on the selected days are removed, then replaced with a copy of the slots from {{ dayNames[copySourceDay] }}.
                  </info-hint>
                  <info-hint v-else variant="primary">
                    Copied slots are added next to the slots already on the selected days.<span v-if="schedule.type.id === 1"> Where they overlap, copied slots take priority.</span>
                  </info-hint>
                </drawer-section>
              </template>

              <template v-else-if="slotToolsView === 'main'">
              <drawer-section title="Slot details" icon="icon-calendar-60" collapsible :expanded.sync="toolsSections.details">
                <template v-if="help_generate">
                  <div class="row">
                    <div class="col-6">
                      <base-input label="Event duration (minutes)" v-on:change="validateHelperFields()" v-model="schedule.slot_duration"></base-input>
                    </div>
                    <div class="col-6" v-if="schedule.type.id === 0">
                      <base-input v-on:change="validateHelperFields()" label="Gap duration (minutes)" v-model="schedule.gap_duration"></base-input>
                    </div>
                  </div>
                </template>
                <label class="text-white d-block">Applicable days</label>
                <div class="mb-3">
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[0]">Mon</base-checkbox>
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[1]">Tue</base-checkbox>
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[2]">Wed</base-checkbox>
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[3]">Thu</base-checkbox>
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[4]">Fri</base-checkbox>
                  <base-checkbox class="mr-2" style="display: inline-block" v-model="applicableDays[5]">Sat</base-checkbox>
                  <base-checkbox style="display: inline-block" v-model="applicableDays[6]">Sun</base-checkbox>
                </div>
                <div v-if="bulk_update_settings" class="toggle-row mb-3">
                  <el-switch active-color="#e14eca" v-model="bulk_time_range" />
                  <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="bulk_time_range = !bulk_time_range">Limit to a time range</label>
                  <el-popover popper-class="otc-pop" trigger="hover" placement="top">
                    <div><div class="popover-body">Only slots that start between these times on the checked days are updated, both times included. A range that ends earlier than it starts runs past midnight.</div></div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info ml-1"></i>
                  </el-popover>
                </div>
                <div v-if="showTimeRange" class="row">
                  <div class="col-6">
                    <base-input :label="help_generate ? 'Start slots on' : 'Slots starting from'">
                      <el-time-picker v-on:input="validateTime(start_time)" v-model="start_time" :format="picker_time_format" placeholder="HH:MM" :clearable="false"></el-time-picker>
                    </base-input>
                  </div>
                  <div class="col-6">
                    <base-input :label="help_generate ? 'End slots on' : 'To'">
                      <el-time-picker v-on:input="validateTime(end_time)" v-model="end_time" :format="picker_time_format" placeholder="HH:MM" :clearable="false"></el-time-picker>
                    </base-input>
                  </div>
                </div>
                <info-hint v-if="showTimeRange && rangeCrossesMidnight" variant="primary">
                  This range runs past midnight. Slots after midnight count toward the night before, so a Friday range also covers early Saturday.
                </info-hint>
                <div v-if="help_generate" class="mb-3">
                  <base-button variant="outlined" tone="danger" size="sm" @click="clearSlots()">
                    <i class="tim-icons icon-trash-simple"></i> Clear slots in range
                  </base-button>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input label="Slot status">
                      <el-select v-model="schedule.status" class="select-primary" placeholder="Status" value-key="id" v-on:change="j++">
                        <el-option v-if="schedule.type.id === 0" v-for="(s, i) in booking_statuses" class="select-primary" :label="s.name" :value="{id: s.id, name: s.name, label: s.label}" :key="'S' + i"></el-option>
                        <el-option v-if="schedule.type.id === 1" v-for="(s, i) in resource_statuses" class="select-primary" :label="s.name" :value="{id: s.id, name: s.name, label: s.label}" :key="'S' + i"></el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-lg-6" v-if="schedule.type.id === 1">
                    <label class="text-white">Concurrent events
                      <el-popover popper-class="otc-pop" trigger="hover" placement="top">
                        <div><div class="popover-body">Number of events this resource can support at the same time. If an event uses ticket-mode blocking, each ticket counts as one event toward this limit.</div></div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </label>
                    <base-input>
                      <el-input-number v-on:input="j++" size="small" v-model="schedule.supported_event_count" :min="0" />
                    </base-input>
                  </div>
                </div>
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 0 && (schedule.status.id === 0 || schedule.status.id === 2 || schedule.status.id === 3)" title="Booking options" icon="icon-settings" collapsible :expanded.sync="toolsSections.booking">
                <div class="toggle-row mb-3">
                  <el-switch active-color="#e14eca" v-model="schedule.allow_late_booking" @change="j++" />
                  <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="schedule.allow_late_booking = !schedule.allow_late_booking; j++">Allow bookings after start time</label>
                </div>
                <info-hint v-if="!schedule.allow_late_booking" variant="primary">
                  Choose how soon before the event start time a customer can book. This setting will help prevent last minute bookings.
                </info-hint>
                <info-hint v-else variant="primary">
                  Allow customers to book up to this amount of time after the event has already started. Useful for events that allow late entry.
                </info-hint>
                <value-period-input
                  class="mb-4"
                  :value="Number(schedule.min_booking_value) || 0"
                  @input="v => { schedule.min_booking_value = v; j++ }"
                  :period="schedule.min_booking_period ? schedule.min_booking_period.id : null"
                  @update:period="setSchedulePeriod('min_booking_period', min_periods, $event)"
                  :periods="min_periods"
                  :label="schedule.allow_late_booking ? 'Maximum time after booking start' : 'Minimum booking notice'"
                  :min="0"
                />
                <info-hint v-if="!schedule.allow_late_booking" variant="primary">
                  Choose what customers see once this slot enters the minimum notice window: a call to book label, a request to book button, or nothing.
                </info-hint>
                <div class="mb-4" v-if="!schedule.allow_late_booking">
                  <label class="text-white">When minimum notice passes</label>
                  <base-input class="mb-0">
                    <el-select v-model="schedulePastNoticeBehavior" class="select-primary" @change="j++">
                      <el-option class="select-primary" label="Show as call to book" :value="0"></el-option>
                      <el-option class="select-primary" label="Show as request to book" :value="1"></el-option>
                      <el-option class="select-primary" label="Hide slot" :value="2"></el-option>
                    </el-select>
                  </base-input>
                </div>
                <info-hint variant="primary">
                  Choose how far in advance customers can book this event. By default, bookings are generated 12 months in advance.
                </info-hint>
                <value-period-input
                  class="mb-2"
                  :value="Number(schedule.max_booking_value) || 0"
                  @input="v => { schedule.max_booking_value = v; j++ }"
                  :period="schedule.max_booking_period ? schedule.max_booking_period.id : null"
                  @update:period="setSchedulePeriod('max_booking_period', max_periods, $event)"
                  :periods="max_periods"
                  label="Maximum bookings in advance"
                  :min="0"
                />
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 0" title="Display options" icon="icon-image-02" collapsible :expanded.sync="toolsSections.display">
                <info-hint v-if="schedule.status.id === 0 && !schedule.allow_late_booking" variant="primary">
                  This text will be visible to customers when a slot is blocked off due to minimum booking notice coming into effect.
                </info-hint>
                <info-hint v-else-if="schedule.status.id === 0" variant="primary">
                  This text will be visible to customers when a slot is blocked off due to maximum time after start coming into effect.
                </info-hint>
                <info-hint v-else variant="primary">
                  This text will be visible to customers when a slot has the status "Call to book".
                </info-hint>
                <label class="text-white" :key="'TB' + j">
                  {{ schedule.status.id === 0 ? (schedule.allow_late_booking ? 'Maximum time after start block off text' : 'Minimum notice block off text') : 'Time slot text' }}
                </label>
                <base-input v-on:change="j++" v-model="schedule.slot_text"></base-input>
                <div class="toggle-row">
                  <el-switch active-color="#e14eca" v-model="schedule.has_external_link" @change="j++" />
                  <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="schedule.has_external_link = !schedule.has_external_link; j++">Link to external page</label>
                </div>
                <div v-if="schedule.has_external_link" class="mt-2">
                  <base-input v-on:change="j++" v-model="schedule.external_link" placeholder="https://example.com"></base-input>
                </div>
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 0" title="Custom message" icon="icon-chat-33" collapsible :expanded.sync="toolsSections.message">
                <custom-message-fields
                  :message.sync="schedule.custom_message"
                  :display.sync="schedule.custom_message_display"
                  :active.sync="schedule.custom_message_active"
                  :preview-time="slotToolsPreviewTime"
                  :error="errs.schedule_custom_message"
                  toggle-label="Show message on these booking slots"
                />
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 1" title="Resource" icon="icon-single-02" collapsible :expanded.sync="toolsSections.resource">
                <resource-category-selector
                  :company-group-id="companyGroupId"
                  :initial-category-id="schedule.resource_category_id"
                  @category-changed="onCategoryChangedSchedule"
                  :error="errs.resource_category_id"
                />
                <div class="toggle-row mb-2">
                  <el-switch v-on:input="j++" active-color="#e14eca" v-on:change="toggleAnonymousResource(schedule)" v-model="schedule.anonymous_resource" />
                  <label class="mb-0 ml-2 text-white">Anonymous resource</label>
                </div>
                <div v-if="schedule.anonymous_resource">
                  <base-input label="Resource label" :error="schedule.label_error" placeholder="Anonymous" v-model="schedule.label"></base-input>
                </div>
                <div v-else>
                  <base-input label="Add staff (search by name or email)" :error="schedule.staff_error">
                    <el-autocomplete style="width: 100%" v-on:input="j++" v-model="schedule.email" :fetch-suggestions="querySearchCu" placeholder="Search" :trigger-on-focus="false" @select="handleSelectRuS">
                      <template #default="{ item }">
                        <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                        <small class="font-italic"><i class="tim-icons icon-email-85"></i> {{ item.email }}</small>
                      </template>
                    </el-autocomplete>
                  </base-input>
                </div>
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 1" title="Blocking rules" icon="icon-lock-circle" collapsible :expanded.sync="toolsSections.blocking">
                <div class="row">
                  <div class="col toggle-row">
                    <el-switch v-on:input="j++" active-color="#e14eca"
                               v-model="schedule.enable_autoblock"  />
                    <label class="mb-0 ml-2">Block events with insufficient resource coverage</label>
                  </div>
                </div>
                <div class="row mt-2" v-if="schedule.enable_autoblock">
                  <div class="col-lg-3">
                    <base-input label="Block slots with the following status">
                      <el-select
                        v-model="schedule.block_status"
                        class="select-primary"
                        placeholder="Status"
                        value-key="id"
                        v-on:change="j++"
                      >
                        <el-option
                          v-for="(s, i) in block_statuses"
                          class="select-primary"
                          :label="s.name"
                          :value="{id: s.id, name: s.name, label: s.label}"
                          :key="'S' + i"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>

                <div class="row" v-if="schedule.enable_autoblock">
                  <div class="col toggle-row">
                    <el-switch v-on:input="j++" active-color="#e14eca"
                               v-model="schedule.include_start_end_time_in_blocking"  />
                    <label class="mb-0 ml-2">Include event start/end time in block rule
                      <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                        <div>
                          <div class="popover-body">When enabled, slots that start or end at the same time are treated as overlapping.
                          </div>
                        </div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </label>
                  </div>
                </div>
                <div class="row" v-if="schedule.enable_autoblock">
                  <div class="col toggle-row">
                    <el-switch v-on:input="j++" active-color="#e14eca"
                               v-model="schedule.apply_to_all_events"  />
                    <label class="mb-0 ml-2">Apply blocking rule to all events</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6" v-if="schedule.enable_autoblock && !schedule.apply_to_all_events">
                    <base-input label="Associated events">
                      <el-select
                        label="Select game"
                        v-model="schedule.linked_games"
                        v-on:change="j++"
                        class="select-primary"
                        value-key="id"
                        multiple
                      >
                        <el-option
                          v-for="(g, i) in games"
                          class="select-primary"
                          :label="g.name"
                          :value="{ name: g.name, id: g.id} "
                          :key="'GG' + i"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col toggle-row">
                    <el-switch v-on:input="onAutoUnblockInput" active-color="#e14eca"
                               v-model="schedule.enable_auto_unblock"  />
                    <label class="mb-0 ml-2">Auto-unblock when bookings change
                      <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                        <div>
                          <div class="popover-body">When enabled, blocked slots will automatically become available when resource capacity allows. Evaluated on any booking change or resource slot update. Choose whether it also restores call-to-book slots, or only blocked slots.
                          </div>
                        </div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </label>
                  </div>
                </div>

                <div v-if="schedule.enable_auto_unblock" class="restore-scope">
              <label class="d-block restore-label">Restore</label>
              <segmented-toggle
                      :value="schedule.exclude_call_to_book_from_auto_unblock ? 'blocked_only' : 'all'"
                      size="sm"
                      :options="unblockScopeOptions"
                      @input="val => { schedule.exclude_call_to_book_from_auto_unblock = (val === 'blocked_only'); j++ }"
                    />
            </div>

                <div class="row">
                  <div class="col toggle-row">
                    <el-switch v-on:input="j++" active-color="#e14eca"
                               v-model="schedule.saturate_on_first_assignment"  />
                    <label class="mb-0 ml-2">Lock resource after assignment
                      <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                        <div>
                          <div class="popover-body">When enabled, this resource is treated as fully occupied after any booking is assigned, regardless of remaining capacity.</div>
                        </div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </label>
                  </div>
                </div>
              </drawer-section>

              <drawer-section v-if="schedule.type.id === 0" title="Slot pricing" icon="icon-coins" collapsible :expanded.sync="toolsSections.pricing">
                <div class="drawer-detail-row text-white">
                  <span>Pricing</span>
                  <span>{{ is_custom_pricing_enabled ? 'Custom' : 'Default' }}</span>
                </div>
                <template v-if="is_custom_pricing_enabled">
                  <div class="drawer-detail-row text-white">
                    <span>Pricing type</span>
                    <span>{{ toolsPricingTypeName }}</span>
                  </div>
                  <div class="drawer-detail-row text-white">
                    <span>Reservation style</span>
                    <span>{{ toolsReservationStyleName }}</span>
                  </div>
                  <div class="drawer-detail-row text-white">
                    <span>Cumulative</span>
                    <span>{{ cumulative_category_pricing ? 'Yes' : 'No' }}</span>
                  </div>
                  <div class="drawer-detail-row text-white">
                    <span>Deposit</span>
                    <span>{{ toolsDepositLabel }}</span>
                  </div>
                  <div v-if="toolsDurationsLabel" class="drawer-detail-row text-white">
                    <span>Durations</span>
                    <span>{{ toolsDurationsLabel }}</span>
                  </div>
                </template>
                <div class="mt-3">
                  <button class="drawer-edit-link text-primary" @click.stop="slotToolsView = 'pricing'">
                    <i class="tim-icons icon-pencil mr-1"></i> Edit pricing
                  </button>
                </div>
              </drawer-section>
              </template>

              <template v-else>
                <slot-pricing-editor
                  ref="toolsPricingEditor"
                  :slot-data="schedulePricingProxy"
                  :pricing-types="pricing_types"
                  :reservation-styles="reservation_styles"
                  :value-types="valueTypes"
                />
              </template>

              <template #footer>
                <div class="footer-actions">
                  <template v-if="slotToolsView === 'pricing'">
                    <base-button type="primary" size="sm" @click="exitToolsPricingView">Done</base-button>
                  </template>
                  <template v-else>
                  <base-button type="secondary" size="sm" @click="closeSlotTools">Cancel</base-button>
                  <base-button v-if="copy_days" type="primary" size="sm" @click="copySlots()">Copy slots</base-button>
                  <base-button v-else-if="help_generate" type="primary" size="sm" @click="generateSlots()">Generate slots</base-button>
                  <base-button v-else type="primary" size="sm" @click="bulkUpdateSlots()">Update slot settings</base-button>
                  </template>
                </div>
              </template>
            </base-drawer>

            <div class="row mt-4">
              <div class="col-12 schedule-calendar">
                <fullCalendar ref="calendar" :options="calendarOptions"/>
              </div>
            </div>
          </div>
        </div>

        <!--    Create schedule-->
        <div class="row mt-2">
          <div class="col">
            <base-button  v-on:click="cancelEditSchedule()" type="default" class="mr-2" >Cancel</base-button>
            <base-button  v-on:click="updateSchedulePrompt()" type="primary" >Update schedule</base-button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <!--    Create / edit time slot drawer-->
  <base-drawer :show="modals.create_slot" :title="slotDrawerTitle" @close="closeSlotDrawer">
    <template v-if="slotDrawerView !== 'main'" #title-prefix>
      <button class="drawer-back-btn" @click="exitPricingView">
        <i class="tim-icons icon-minimal-left"></i>
      </button>
    </template>

    <template v-if="slotDrawerView === 'main'">
    <drawer-section title="Slot details" icon="icon-calendar-60" collapsible :expanded.sync="slotSections.details">
      <div class="toggle-row mb-3">
        <el-switch active-color="#e14eca" v-model="is_all_day" @change="handleAllDayToggle" />
        <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="is_all_day = !is_all_day; handleAllDayToggle()">All day event</label>
      </div>
      <div v-if="is_all_day" class="mb-3">
        <info-hint variant="primary">This text will be displayed on the booking slot instead of the time range for all-day events.</info-hint>
        <label class="text-white">All day event text</label>
        <base-input v-model="all_day_text" placeholder="e.g., All day"></base-input>
      </div>

      <div class="row" v-if="!is_all_day">
        <div class="col-lg-6">
          <base-input label="Start day">
            <el-select
              v-model="selectedSlot.start_day"
              class="select-primary"
              name="email_group"
              placeholder="Day of the week"
              value-key="id"
              v-on:change="adjustDate(selectedSlot.start_day.id, selectedSlot.start, 0)"
            >
              <el-option
                v-for="(day, index) in days_of_week"
                class="select-primary"
                :label="day.name"
                :value="{name: day.name, id: day.id}"
                :key="'SD' + index"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col">
          <base-input :label="'Start time'" :error="errs.start_date_slot">
            <el-time-picker v-on:input="validateTime(selectedSlot.start, selectedSlot.start_reference)"
                            v-model="selectedSlot.start"
                            :format="picker_time_format" placeholder="HH:MM"
            ></el-time-picker>
          </base-input>
        </div>
      </div>
      <div class="row" v-if="!is_all_day">
        <div class="col-lg-6">
          <base-input label="End day">
            <el-select
              v-model="selectedSlot.end_day"
              class="select-primary"
              name="email_group"
              placeholder="Day of the week"
              value-key="id"
              v-on:change="adjustDate(selectedSlot.end_day.id, selectedSlot.end, 1)"
            >
              <el-option
                v-for="(day, index) in days_of_week"
                class="select-primary"
                :label="day.name"
                :value="{name: day.name, id: day.id}"
                :key="'ED' + index"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col">
          <base-input :label="'End time: '" :error="errs.end_date_slot">
            <el-time-picker v-on:input="validateTime(selectedSlot.end, selectedSlot.end_reference)"
                            v-model="selectedSlot.end"
                            :format="picker_time_format" placeholder="HH:MM"
            ></el-time-picker>
          </base-input>
        </div>
      </div>
      <!--        Slot status-->
      <div class="row">
        <div class="col-lg-6" v-if="schedule.type.id === 0">
          <base-input label="Slot status">
            <el-select
              v-model="selectedSlot.status"
              class="select-primary"
              placeholder="Status"
              value-key="id"
            >
              <el-option
                         v-for="(s, i) in booking_statuses"
                         class="select-primary"
                         :label="s.name"
                         :value="{id: s.id, name: s.name, label: s.label}"
                         :key="'S' + i"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-lg-4" v-if="schedule.type.id === 1">
          <label>
            <div>Assignment priority
              <el-popover popper-class="otc-pop" trigger="hover"
                          placement="top">

                <div>
                  <div class="popover-body">Defines the order of priority the resource will be
                    allocated to an event when concurrent resources exist.
                     For example, 1 is the highest priority and will be allocated first.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </div>
          </label>
          <base-input>
            <el-select
              v-model="selectedSlot.priority"
              class="select-primary"
              placeholder="Priority"
              value-key="id"
            >
              <el-option
                v-for="(pr, i) in priorities"
                class="select-primary"
                :label="pr.toString()"
                :value="pr"
                :key="'PR' + i"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-lg-6 col-6" v-if="schedule.type.id === 1">
          <label>
            <div>Concurrent events
              <el-popover popper-class="otc-pop" trigger="hover"
                          placement="top">

                <div>
                  <div class="popover-body">Number of events this resource can support at the same time. If an event uses ticket-mode blocking, each ticket counts as one event toward this limit.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </div>
          </label>
          <div class="row">
            <div class="col-lg-6">
              <base-input>
                <el-input-number size="small" v-model="selectedSlot.supported_event_count" :min="0" />
              </base-input>
            </div>
          </div>
        </div>
      </div>
    </drawer-section>

    <drawer-section v-if="schedule.type.id === 0 && (selectedSlot.status.id === 0 || selectedSlot.status.id === 2 || selectedSlot.status.id === 3)" title="Booking options" icon="icon-settings" collapsible :expanded.sync="slotSections.booking">
      <div class="toggle-row mb-3">
        <el-switch active-color="#e14eca" v-model="selectedSlot.allow_late_booking" />
        <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="selectedSlot.allow_late_booking = !selectedSlot.allow_late_booking">Allow bookings after start time</label>
      </div>

      <info-hint v-if="!selectedSlot.allow_late_booking" variant="primary">
        Choose how soon before the event start time a customer can book. This setting will help prevent last minute bookings.
      </info-hint>
      <info-hint v-else variant="primary">
        Allow customers to book up to this amount of time after the event has already started. Useful for events that allow late entry.
      </info-hint>
      <value-period-input
        class="mb-4"
        :value="Number(selectedSlot.min_booking_value) || 0"
        @input="v => selectedSlot.min_booking_value = v"
        :period="selectedSlot.min_booking_period ? selectedSlot.min_booking_period.id : null"
        @update:period="setSlotPeriod('min_booking_period', min_periods, $event)"
        :periods="min_periods"
        :label="selectedSlot.allow_late_booking ? 'Maximum time after booking start' : 'Minimum booking notice'"
        :min="0"
      />

      <info-hint v-if="!selectedSlot.allow_late_booking" variant="primary">
        Choose what customers see once this slot enters the minimum notice window: a call to book label, a request to book button, or nothing.
      </info-hint>
      <div class="mb-4" v-if="!selectedSlot.allow_late_booking">
        <label class="text-white">When minimum notice passes</label>
        <base-input class="mb-0">
          <el-select v-model="selectedSlotPastNoticeBehavior" class="select-primary" @change="j++">
            <el-option class="select-primary" label="Show as call to book" :value="0"></el-option>
            <el-option class="select-primary" label="Show as request to book" :value="1"></el-option>
            <el-option class="select-primary" label="Hide slot" :value="2"></el-option>
          </el-select>
        </base-input>
      </div>

      <info-hint variant="primary">
        Choose how far in advance customers can book this event. By default, bookings are generated 12 months in advance.
      </info-hint>
      <value-period-input
        class="mb-2"
        :value="Number(selectedSlot.max_booking_value) || 0"
        @input="v => selectedSlot.max_booking_value = v"
        :period="selectedSlot.max_booking_period ? selectedSlot.max_booking_period.id : null"
        @update:period="setSlotPeriod('max_booking_period', max_periods, $event)"
        :periods="max_periods"
        label="Maximum bookings in advance"
        :min="0"
      />
</drawer-section>

    <drawer-section v-if="schedule.type.id === 0" title="Display options" icon="icon-image-02" collapsible :expanded.sync="slotSections.display">
      <info-hint v-if="selectedSlot.status.id === 0 && !selectedSlot.allow_late_booking" variant="primary">
        This text will be visible to customers when a slot is blocked off due to minimum booking notice coming into effect.
      </info-hint>
      <info-hint v-else-if="selectedSlot.status.id === 0" variant="primary">
        This text will be visible to customers when a slot is blocked off due to maximum time after start coming into effect.
      </info-hint>
      <info-hint v-else variant="primary">
        This text will be visible to customers when a slot has the status "Call to book".
      </info-hint>
      <label class="text-white" :key="'B' + j">
        {{ selectedSlot.status.id === 0 ? (selectedSlot.allow_late_booking ? 'Maximum time after start block off text' : 'Minimum notice block off text') : 'Time slot text' }}
      </label>
      <base-input v-on:change="j++" v-model="selectedSlot.slot_text"></base-input>

      <div class="toggle-row">
        <el-switch active-color="#e14eca" v-model="selectedSlot.has_external_link" @change="j++" />
        <label class="mb-0 ml-2 text-white" style="cursor: pointer" @click="selectedSlot.has_external_link = !selectedSlot.has_external_link; j++">Link to external page</label>
      </div>
      <div v-if="selectedSlot.has_external_link" class="mt-2">
        <base-input v-on:change="j++" v-model="selectedSlot.external_link" placeholder="https://example.com"></base-input>
      </div>
</drawer-section>

    <drawer-section v-if="schedule.type.id === 0" title="Custom message" icon="icon-chat-33" collapsible :expanded.sync="slotSections.message">
      <custom-message-fields
        :message.sync="selectedSlot.custom_message"
        :display.sync="selectedSlot.custom_message_display"
        :active.sync="selectedSlot.custom_message_active"
        :preview-time="slotPreviewTime"
        :error="errs.custom_message"
        toggle-label="Show message on booking slots from this template"
      />
    </drawer-section>

    <drawer-section v-if="schedule.type.id === 1" title="Resource" icon="icon-single-02" collapsible :expanded.sync="slotSections.resource">
        <!-- Category Section -->
        <resource-category-selector
          :company-group-id="companyGroupId"
          :initial-category-id="selectedSlot.resource_category_id"
          @category-changed="onCategoryChanged"
          :error="errs.resource_category_id"
        />
        <!-- End Category Section -->

        <div class="row mb-2">
          <div class="col">
            <div class="toggle-row">
              <el-switch active-color="#e14eca" v-on:change="toggleAnonymousResource(selectedSlot)" v-model="selectedSlot.anonymous_resource" />
              <label class="mb-0 ml-2 text-white">Anonymous resource</label>
            </div>
          </div>
        </div>

        <div class="row" v-if="selectedSlot.anonymous_resource">
          <div class="col-lg-6">
            <base-input label="Resource label" :error="selectedSlot.label_error" placeholder="Anonymous" v-model="selectedSlot.label"></base-input>
          </div>
        </div>

        <div class="row" v-if="!selectedSlot.anonymous_resource">
          <div class="col-lg-6">
            <base-input label="Add staff (search by name or email)" :error="selectedSlot.staff_error">
              <el-autocomplete style="width: 100%"
                               v-model="selectedSlot.email"
                               :fetch-suggestions="querySearchCu"
                               placeholder="Search"
                               :trigger-on-focus="false"
                               @select="handleSelectRu"
              >
                <template #default="{ item }">
                  <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                  <small class="font-italic">
                    <i class="tim-icons icon-email-85"></i> {{item.email }} &nbsp;
                  </small>
                </template>
              </el-autocomplete>
            </base-input>
          </div>
        </div>
    </drawer-section>

    <drawer-section v-if="schedule.type.id === 1" title="Blocking rules" icon="icon-lock-circle" collapsible :expanded.sync="slotSections.blocking">
        <div class="row">
          <div class="col toggle-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedSlot.enable_autoblock"  />
            <label class="mb-0 ml-2">Block events with insufficient resource coverage</label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6"  v-if="selectedSlot.enable_autoblock">
            <base-input label="Block slots with the following status">
              <el-select
                v-model="selectedSlot.block_status"
                class="select-primary"
                placeholder="Status"
                value-key="id"
              >
                <el-option
                  v-for="(s, i) in block_statuses"
                  class="select-primary"
                  :label="s.name"
                  :value="{id: s.id, name: s.name, label: s.label}"
                  :key="'S' + i"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="selectedSlot.enable_autoblock">
          <div class="col toggle-row">
            <el-switch v-on:input="j++" active-color="#e14eca"
                       v-model="selectedSlot.include_start_end_time_in_blocking"  />
            <label class="mb-0 ml-2">Include event start/end time in block rule
              <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, slots that start or end at the same time are treated as overlapping.
                  </div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row" v-if="selectedSlot.enable_autoblock">
          <div class="col toggle-row">
            <el-switch v-on:input="j++" active-color="#e14eca"
                       v-model="selectedSlot.apply_to_all_events"  />
            <label class="mb-0 ml-2">Apply blocking rule to all events</label>
          </div>
        </div>

        <div class="row">
          <div class="col" v-if="selectedSlot.enable_autoblock && !selectedSlot.apply_to_all_events">
            <base-input label="Associated events">
              <el-select
                label="Select game"
                v-model="selectedSlot.linked_games"
                v-on:change="j++"
                class="select-primary"
                value-key="id"
                multiple
              >
                <el-option
                  v-for="(g, i) in games"
                  class="select-primary"
                  :label="g.name"
                  :value="{ name: g.name, id: g.id} "
                  :key="'G' + i"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col toggle-row">
            <el-switch v-on:input="onAutoUnblockInput" active-color="#e14eca"
                       v-model="selectedSlot.enable_auto_unblock"  />
            <label class="mb-0 ml-2">Auto-unblock when bookings change
              <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, blocked slots will automatically become available when resource capacity allows. Evaluated on any booking change or resource slot update. Choose whether it also restores call-to-book slots, or only blocked slots.
                  </div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>

        <div v-if="selectedSlot.enable_auto_unblock" class="restore-scope">
          <label class="d-block restore-label">Restore</label>
          <segmented-toggle
            :value="selectedSlot.exclude_call_to_book_from_auto_unblock ? 'blocked_only' : 'all'"
            size="sm"
            :options="unblockScopeOptions"
            @input="val => { selectedSlot.exclude_call_to_book_from_auto_unblock = (val === 'blocked_only'); j++ }"
          />
        </div>

        <div class="row">
          <div class="col toggle-row">
            <el-switch v-on:input="j++" active-color="#e14eca"
                       v-model="selectedSlot.saturate_on_first_assignment"  />
            <label class="mb-0 ml-2">Lock resource after assignment
              <el-popover popper-class="otc-pop" trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, this resource is treated as fully occupied after any booking is assigned, regardless of remaining capacity.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
    </drawer-section>

    <drawer-section v-if="schedule.type.id === 0" title="Slot pricing" icon="icon-coins" collapsible :expanded.sync="slotSections.pricing">
      <div class="drawer-detail-row text-white">
        <span>Pricing</span>
        <span>{{ selectedSlot.is_custom_pricing_enabled ? 'Custom' : 'Default' }}</span>
      </div>
      <template v-if="selectedSlot.is_custom_pricing_enabled">
        <div class="drawer-detail-row text-white">
          <span>Pricing type</span>
          <span>{{ slotPricingTypeName }}</span>
        </div>
        <div class="drawer-detail-row text-white">
          <span>Reservation style</span>
          <span>{{ slotReservationStyleName }}</span>
        </div>
        <div class="drawer-detail-row text-white">
          <span>Cumulative</span>
          <span>{{ selectedSlot.cumulative_category_pricing ? 'Yes' : 'No' }}</span>
        </div>
        <div class="drawer-detail-row text-white">
          <span>Deposit</span>
          <span>{{ slotDepositLabel }}</span>
        </div>
        <div v-if="slotDurationsLabel" class="drawer-detail-row text-white">
          <span>Durations</span>
          <span>{{ slotDurationsLabel }}</span>
        </div>
      </template>
      <div class="mt-3">
        <button class="drawer-edit-link text-primary" @click.stop="slotDrawerView = 'pricing'">
          <i class="tim-icons icon-pencil mr-1"></i> Edit pricing
        </button>
      </div>
    </drawer-section>

    <div v-if="selectedSlot.editing" class="danger-action-card">
      <div class="danger-action-info">
        <span class="danger-action-label text-white">Delete slot</span>
        <span class="danger-action-hint text-muted">Permanently remove this time slot</span>
      </div>
      <base-button size="sm" class="danger-action-btn" @click="deleteTimeSlot()">
        <i class="tim-icons icon-trash-simple mr-1" style="font-size: 11px;"></i> Delete
      </base-button>
    </div>
    </template>

    <template v-else>
      <slot-pricing-editor
        ref="slotPricingEditor"
        :slot-data="selectedSlot"
        :pricing-types="pricing_types"
        :reservation-styles="reservation_styles"
        :value-types="valueTypes"
      />
    </template>

    <template #footer>
      <div class="footer-actions">
        <template v-if="slotDrawerView === 'pricing'">
          <base-button type="primary" size="sm" @click="exitPricingView">Done</base-button>
        </template>
        <template v-else>
          <base-button type="secondary" size="sm" @click="closeSlotDrawer">Cancel</base-button>
          <base-button v-if="!selectedSlot.editing" type="primary" size="sm" @click="createSlotSave()">Create</base-button>
          <base-button v-else type="primary" size="sm" @click="updateSlot()">Update</base-button>
        </template>
      </div>
    </template>
  </base-drawer>

    <review-future-slots-drawer
    :show="modals.future_slots"
    :rows="future_slots"
    :insufficient-resources="has_insufficient_resource_slots > 0"
    :loading="loading"
    :confirm-label="slot_creation_source ? 'Activate' : 'Update'"
    @close="modals.future_slots = false"
    @confirm="modals.future_slots = false; slot_creation_source ? activateSchedule('activate', schedule) : updateSchedule()"
  />
</div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import {TimePicker, Dropdown, DropdownItem, DropdownMenu, Switch, Autocomplete} from "element-ui";
import FullCalendar from "@fullcalendar/vue";
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Badge from "@/components/Badge";
import moment from "moment";
import { sortDurations } from '@/util/pricing'

// "15 min (default), 60 min, 90 min" or '' when the feature is off or nothing is configured
function durationsSummary(enabled, durations) {
  if (!enabled) return ''
  let list = durations
  if (typeof list === 'string') { try { list = JSON.parse(list) } catch (e) { list = [] } }
  if (!Array.isArray(list) || list.length === 0) return ''
  return sortDurations(list).map(d => `${d.duration_minutes} min${Number(d.is_default) === 1 || d.is_default === true ? ' (default)' : ''}`).join(', ')
}

// Every key the slot tools drawer binds. getSchedule merges the API row onto a fresh copy
// so these keys exist when the object becomes reactive; keys added afterwards are not
// reactive and $set on an existing key does not notify (min/max period dropdowns froze).
function defaultSchedule() {
  return {
    name: '',
    type: {id: 0, name: 'Booking schedule'},
    start_date: new Date(),
    end_date: new Date(),
    duration_type: {
      id: 1,
      label: 'Recurring',
    },
    games: '',
    resource_count: 1,
    supported_event_count: 1,
    slot_duration: 60,
    gap_duration: 30,
    status: {id: 0, name: 'Available', label: 'available'},
    min_booking_period: {id: 1, label: 'hour(s)'},
    min_booking_value: 1,
    hide_past_min_notice: 0,
    request_past_min_notice: 0,
    allow_late_booking: false,
    max_booking_period: {id: 2, label: 'month(s)'},
    max_booking_value: 6,
    slot_text: 'Call to book',
    custom_message: '',
    custom_message_display: 'text',
    custom_message_active: false,
    external_link: '',
    has_external_link: false,
    active: 0,
    enable_autoblock: true,
    block_status:  {id: 1, name: 'Blocked', label: 'blocked'},
    anonymous_resource: true,
    label: 'Anonymous',
    label_error: '',
    staff_error: '',
    email: null,
    company_user_id: null,
    include_start_end_time_in_blocking: false,
    apply_to_all_events: true,
    linked_games: [],
    resource_category_id: null,
    enable_auto_unblock: false,
    exclude_call_to_book_from_auto_unblock: false,
    saturate_on_first_assignment: false
  }
}
import _ from "lodash";
import { splitCategoriesByDuration, flattenCategoriesByDuration } from "@/util/pricing";
import axios from "axios";
import currencies from "@/assets/currencies.json";
import { v4 as uuidv4 } from 'uuid';
import { DAY_NAMES, dayIndex, formatDayList, buildDayCopies, crossesMidnight, slotStartsInRange, placeInWeek, formatRangeScope } from '@/util/scheduleDayTools';
import { validateSlotPricing } from '@/util/slotPricingValidation';
import { AUTO_UNBLOCK_WARNING } from '@/util/autoUnblockWarning';
import ResourceCategorySelector from "@/components/ResourceCategories/ResourceCategorySelector"
import ReviewFutureSlotsDrawer from '@/components/ReviewFutureSlotsDrawer.vue';
import { buildFutureSlotRows, hasFutureSlotConflicts, buildFutureSlotFlags } from '@/util/scheduleFutureSlots';

export default {
  name: "EditSchedule",
  components: {
    ReviewFutureSlotsDrawer,
    BreadcrumbItem,
    Breadcrumb,
    [TimePicker.name]: TimePicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Switch.name]: Switch,
    [Autocomplete.name]: Autocomplete,
    FullCalendar,
    Badge,
    ResourceCategorySelector
  },
  data() {
    return {
      // Live generating / blocking status, read from the schedules list endpoint so the
      // edit form (loaded by getSchedule) is never re-fetched and unsaved edits survive
      status_row: null,
      status_polling: null,
      status_grace_until: 0,
      is_all_day: false,
      all_day_text: 'All day',
      companyGroupId: JSON.parse(localStorage.getItem('group')).id,
      first_day_of_week: JSON.parse(localStorage.getItem('group')).first_day_of_week,
      priorities: [1],
      originalSlot: '',
      days_of_week: [
        { "id": 0, "name": "Sunday" },
        { "id": 1, "name": "Monday" },
        { "id": 2, "name": "Tuesday" },
        { "id": 3, "name": "Wednesday" },
        { "id": 4, "name": "Thursday" },
        { "id": 5, "name": "Friday" },
        { "id": 6, "name": "Saturday" }
      ],
      is_public_booking: {id: 0},
      reservation_styles: [
        {
          id: 0,
          name: 'Private booking'
        },
        {
          id: 1,
          name: 'Public booking'
        },
      ],
      edit_resource_user: false,
      currency_symbol: '$',
      currencies: currencies.currencies,
      slotDrawerView: 'main',
      slotToolsView: 'main',
      toolsSections: { details: true, booking: false, display: false, message: false, resource: false, blocking: false, pricing: false },
      slotSections: { details: true, booking: false, display: false, message: false, resource: false, blocking: false, pricing: false },
      allow_deposit: 0,
      deposit_amount: 1,
      deposit_type: {id: 0},
      require_deposit: 0,
      pricing_categories: [{
        category: 'Person',
        minimum_participants: 0,
        maximum_participants: null,
        default_participants: 0,
        pricing: [{min_players: 1, max_players: 2, price: 0}]
      }],
      pricing_type: {id: 1},
      cumulative_category_pricing: 1,
      hide_pricing_rate: 0,
      limit_purchase_category: 0,
      is_custom_pricing_enabled: false,
      //Multiple durations (page-level defaults copied into generated templates)
      enable_multiple_durations: false,
      durations: [],
      active_duration_minutes: null,
      pricing_types: [
        {
          id: 1,
          name: 'Per person'
        },
        {
          id: 2,
          name: 'Flat'
        },
      ],
      valueTypes: [
        {
          name: 'Per booking',
          id: 0
        },
        {
          name: 'Per participant',
          id: 1
        }
      ],
      has_insufficient_resource_slots: 0,
      slot_creation_source: 0,
      future_slots: buildFutureSlotRows({}),
      dialog: {
        show: false,
        variant: 'warning',
        title: '',
        message: '',
        showCancel: false,
        confirmText: 'Ok',
        confirmVariant: 'primary',
        onConfirm: null
      },
      help_generate: false,
      bulk_update_settings: false,
      bulk_time_range: false,
      copy_days: false,
      copySourceDay: 0,
      copyMode: 'replace',
      copyModeOptions: [
        { value: 'replace', label: 'Replace' },
        { value: 'add', label: 'Add' }
      ],
      dayNames: DAY_NAMES,
      loading: false,
      j: 0,
      // Set when staff switch auto-unblock on; the save then shows AUTO_UNBLOCK_WARNING.
      autoUnblockTurnedOn: false,
      start_time: new Date(),
      end_time: new Date(),
      schedule: defaultSchedule(),
      schedule_name: '',
      errs: {
        name: '',
        start_date: '',
        end_date: '',
        end_date_slot: '',
        start_date_slot: '',
        custom_message: '',
        schedule_custom_message: ''
      },
      max_periods: [{id: 0,label: 'day(s)'}, {id: 1, label: 'week(s)'}, {id: 2, label: 'month(s)'}, {id: 3,label: 'year(s)'}],
      min_periods: [{id: 0, label: 'minute(s)'}, {id: 1, label: 'hour(s)'}, {id: 2, label: 'day(s)'}, {id: 3, label: 'week(s)'}, {id: 4, label: 'month(s)'}],
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      applicableDays: [false, false, false, false, true, true, true],
      picker_time_format: 'hh:mm A',
      day_of_week: '',
      date_format_cal: '',
      games: [],
      duration_types: [
        {
          id: 1,
          label: 'Recurring',
        },
        {
          id: 0,
          label: 'Between selected dates',
        },
        {
          id: 2,
          label: 'Closed period',
        }
      ],
      calendarOptions: {
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        slotLabelFormat: function (date) {
          let time_format = JSON.parse(localStorage.getItem('group')).time_format

          if(time_format === 'HH:mm') {
            let hour = date.date.hour
            let minute = '00'
            if (date.date.minute == 0){
              return hour + ':' + minute
            }
          } else {
            let hour = date.date.hour
            let dd = 'AM'
            if (date.date.minute == 0){
              if (parseInt(hour) >= 12) {
                hour = parseInt(date.date.hour) - 12;
                dd = 'PM'

              }
              if (hour == 0) {
                hour = 12;
              }
              return hour + ':00 ' + dd
            }
          }
        },
        // schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        headerToolbar: false,
        height: 'auto',
        allDaySlot: false,
        allDayText: 'All day',
        scrollTime: '10:00:00',
        stickyHeaderDates: true,
        slotDuration: '00:15:00',
        snapDuration: '00:05:00',
        slotLabelInterval: 15,
        initialView: 'timeGridWeek',
        firstDay: 1,
        visibleRange: {
          start: '2023-01-02', // A Monday to ensure the week starts from Monday
          end: '2023-01-09'
        },
        dayHeaderContent: (args) => {
          return { html: args.date.toLocaleString('en', { weekday: 'long' }) };
        },
        nowIndicator: false,
        initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        select: this.createTimeSlot,
        eventClick: this.editSlot,
        eventChange: this.updateSlotInfo,
        eventContent: function (arg) {
          let time_format = JSON.parse(localStorage.getItem('group')).time_format
          if(time_format === 'hh:mm'){
            time_format = time_format + ' A'
          }

          let slotInfo = arg.event.extendedProps && arg.event.extendedProps.slotInfo;
          let eventTextColor = arg.event.textColor || "#FFFFFF";
          let customHtml = "<div style='padding-left: 3px; overflow: hidden'>";

          // Check if this is an all-day event
          if(arg.event.allDay && slotInfo && slotInfo.is_all_day) {
            customHtml += "<p style='font-size: x-small; color: " + eventTextColor + "'>" +
              (slotInfo.all_day_text || 'All day') + "</p>";
          } else {
            let start = moment(arg.event.start).format(time_format)
            let end = moment(arg.event.end).format(time_format)
            customHtml += "<p style='font-size: x-small; color: " + eventTextColor + "'>" + start +
              " - " + end + "</p>";
          }

          customHtml += "<h5 style='color: " + eventTextColor + "'>" + arg.event._def.title + "</h5>" +
            "</div>"
          return { html: customHtml }
        },
      },
      modals: {
        create_slot: false,
        future_slots: false
      },
      booking_statuses: [
        {id: 0, name: 'Available', label: 'available'},
        {id: 2, name: 'Call to book', label: 'call_to_book'},
        {id: 3, name: 'Requestable', label: 'requestable'}
      ],
      block_statuses: [
        {id: 1, name: 'Blocked', label: 'blocked'},
        {id: 2, name: 'Call to book', label: 'call_to_book'}
      ],
      unblockScopeOptions: [
        { value: 'all', label: 'Blocked & call to book' },
        { value: 'blocked_only', label: 'Blocked only' }
      ],
      resource_statuses: [{id: 0, name: 'Available', label: 'available'}],
      selectedSlot: {
        start: new Date('2023-01-02'),
        start_reference: new Date('2023-01-02'),
        end: new Date('2023-01-09'),
        end_reference: new Date('2023-01-09'),
        status: {id: 0, name: 'Available'},
        editing: false,
        min_booking_period: {id: 1, label: 'hour(s)'},
        min_booking_value: 1,
        hide_past_min_notice: 0,
        request_past_min_notice: 0,
        allow_late_booking: false,
        max_booking_period: {id: 2, label: 'month(s)'},
        max_booking_value: 6,
        slot_text: '',
        custom_message: '',
        custom_message_display: 'text',
        custom_message_active: false,
        has_external_link: false,
        external_link: '',
        is_public_booking: {id: 0},
        resource_assignee_value: '',
        apply_to_all_events: true,
        include_start_end_time_in_blocking: false,
        enable_auto_unblock: false,
        exclude_call_to_book_from_auto_unblock: false,
        saturate_on_first_assignment: false
      },
      schedule_types: [
        {id: 0, name: 'Booking schedule'}, {id: 1, name: 'Resource schedule'}
      ],
    }
  },
  computed: {
    // Same "creation done" rule the schedules list uses; settled until the first status read
    statusCreationDone(){
      const s = this.status_row
      if (!s) return true
      return Boolean(s.record_creation_completed || (s.expected_number_of_records > 0 && s.created_number_of_records >= s.expected_number_of_records))
    },
    isAutoblocking(){
      const s = this.status_row || this.schedule
      return this.statusCreationDone && s.autoblocking_completed === 0
    },
    statusInProgress(){
      return !this.statusCreationDone || this.isAutoblocking
    },
    slotToolsOpen(){
      return Boolean(this.help_generate || this.bulk_update_settings || this.copy_days)
    },
    slotToolsTitle(){
      if(this.slotToolsView === 'pricing') return 'Custom pricing'
      if(this.copy_days) return 'Copy day'
      return this.help_generate ? 'Generate slots' : 'Bulk update time slot settings'
    },
    toolsPricingTypeName(){
      const pt = this.pricing_type ? _.find(this.pricing_types, { id: this.pricing_type.id }) : null
      return pt ? pt.name : ''
    },
    toolsReservationStyleName(){
      const rs = this.is_public_booking ? _.find(this.reservation_styles, { id: this.is_public_booking.id }) : null
      return rs ? rs.name : ''
    },
    // Multiple durations: a template's lengths, ascending, default marked
    toolsDurationsLabel(){
      return durationsSummary(this.enable_multiple_durations, this.durations)
    },
    slotDurationsLabel(){
      const slot = this.selectedSlot || {}
      return durationsSummary(slot.enable_multiple_durations, slot.durations)
    },
    toolsDepositLabel(){
      if(!this.allow_deposit) return 'Disabled'
      const prefix = this.require_deposit ? 'Required' : 'Allowed'
      return prefix + ', ' + this.currency_symbol + (this.deposit_amount || 0)
    },
    // In-app link back to the list, on the tab this schedule belongs to
    schedulesLink(){
      const type = this.$route.query.type
      return { path: '/bookings/schedules', query: type !== undefined ? { tab: String(type) } : {} }
    },
    showTimeRange(){
      return Boolean(this.help_generate || (this.bulk_update_settings && this.bulk_time_range))
    },
    rangeCrossesMidnight(){
      return Boolean(this.start_time && this.end_time && crossesMidnight(this.start_time, this.end_time))
    },
    slotToolsPreviewTime(){
      if(this.help_generate && this.start_time){
        const m = moment(this.start_time)
        if(m.isValid()) return m.format(this.picker_time_format)
      }
      // No concrete slot in bulk update; show a sample time in the group's format
      return moment().hour(12).minute(0).format(this.picker_time_format)
    },
    slotDrawerTitle(){
      if(this.slotDrawerView === 'pricing') return 'Custom pricing'
      return this.selectedSlot.editing ? 'Edit time slot' : 'Create time slot'
    },
    slotPricingTypeName(){
      const pt = this.selectedSlot.pricing_type ? _.find(this.pricing_types, { id: this.selectedSlot.pricing_type.id }) : null
      return pt ? pt.name : ''
    },
    slotReservationStyleName(){
      const rs = this.selectedSlot.is_public_booking ? _.find(this.reservation_styles, { id: this.selectedSlot.is_public_booking.id }) : null
      return rs ? rs.name : ''
    },
    slotDepositLabel(){
      if(!this.selectedSlot.allow_deposit) return 'Disabled'
      const prefix = this.selectedSlot.require_deposit ? 'Required' : 'Allowed'
      return prefix + ', ' + this.currency_symbol + (this.selectedSlot.deposit_amount || 0)
    },
    slotPreviewTime(){
      if(this.is_all_day) return this.all_day_text || 'All day'
      const m = moment(this.selectedSlot.start)
      return m.isValid() ? m.format(this.picker_time_format) : ''
    },
    // Single control over the two past-notice columns. 0 = call to book
    // (both flags off), 1 = request to book, 2 = hide slot. $set keeps the
    // fields reactive on schedules loaded before the columns existed.
    schedulePastNoticeBehavior: {
      get() {
        if (Number(this.schedule.request_past_min_notice) === 1) return 1;
        if (Number(this.schedule.hide_past_min_notice) === 1) return 2;
        return 0;
      },
      set(v) {
        this.$set(this.schedule, 'request_past_min_notice', v === 1 ? 1 : 0);
        this.$set(this.schedule, 'hide_past_min_notice', v === 2 ? 1 : 0);
      }
    },
    selectedSlotPastNoticeBehavior: {
      get() {
        if (Number(this.selectedSlot.request_past_min_notice) === 1) return 1;
        if (Number(this.selectedSlot.hide_past_min_notice) === 1) return 2;
        return 0;
      },
      set(v) {
        this.$set(this.selectedSlot, 'request_past_min_notice', v === 1 ? 1 : 0);
        this.$set(this.selectedSlot, 'hide_past_min_notice', v === 2 ? 1 : 0);
      }
    }
  },
  watch: {
    'modals.create_slot'(){
      this.syncEscListener()
    },
    slotToolsOpen(){
      this.syncEscListener()
    }
  },
  created() {
    this.schedulePricingProxy = this.buildSchedulePricingProxy()
    this._onEscKey = (e) => {
      if(e.key !== 'Escape') return
      if(this.modals.create_slot){
        this.closeSlotDrawer()
      } else if(this.slotToolsOpen){
        this.closeSlotTools()
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._onEscKey)
    this.stopStatusPolling()
  },
  methods: {
    async getScheduleStatus(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules'
      try {
        const response = await this.axios.get(url, config)
        const all = (response.data.schedules || []).concat(response.data.resource_schedules || [])
        this.status_row = _.find(all, s => String(s.id) === String(this.$route.query.id)) || null
      } catch (err) {
        // Status is informational; a failed poll just tries again next tick
        console.log(err)
        return
      }
      if (!this.statusInProgress && Date.now() > this.status_grace_until) {
        this.stopStatusPolling()
      }
    },
    startStatusPolling(){
      // Grace window: the workflow marks the schedule as generating ~1s after the
      // request that started it returns, so the first read can still see it settled
      this.status_grace_until = Date.now() + 15000
      this.stopStatusPolling()
      this.getScheduleStatus()
      this.status_polling = setInterval(this.getScheduleStatus, 3000)
    },
    stopStatusPolling(){
      if (this.status_polling) clearInterval(this.status_polling)
      this.status_polling = null
    },
    showDialog(opts) {
      this.dialog = Object.assign({ showCancel: false, confirmText: 'Ok', confirmVariant: 'primary', onConfirm: null }, opts, { show: true })
    },
    onDialogConfirm() {
      const action = this.dialog.onConfirm
      this.dialog.show = false
      this.dialog.onConfirm = null
      if (action) action()
    },
    closeSlotTools(){
      this.help_generate = false
      this.bulk_update_settings = false
      this.copy_days = false
      this.slotToolsView = 'main'
    },
    resetSlotToolsState(){
      this.slotToolsView = 'main'
      this.toolsSections = { details: true, booking: false, display: false, message: false, resource: false, blocking: false, pricing: false }
    },
    setSchedulePeriod(field, list, id){
      this.$set(this.schedule, field, _.find(list, { id: id }))
    },
    exitToolsPricingView(){
      if(this.$refs.toolsPricingEditor && !this.$refs.toolsPricingEditor.validate()) return
      this.slotToolsView = 'main'
    },
    validateToolsPricing(){
      const result = validateSlotPricing({ enabled: !!this.is_custom_pricing_enabled, categories: this.pricing_categories })
      if(!result.valid){
        this.slotToolsView = 'pricing'
        this.$nextTick(() => { if(this.$refs.toolsPricingEditor) this.$refs.toolsPricingEditor.validate() })
      }
      return result.valid
    },
    buildSchedulePricingProxy(){
      // Lets the shared SlotPricingEditor edit the page-level pricing fields
      // (used by generateSlots/bulkUpdateSlots) through one object.
      const vm = this
      const proxy = {}
      for(const key of ['is_custom_pricing_enabled', 'pricing_type', 'is_public_booking', 'cumulative_category_pricing', 'hide_pricing_rate',
        'limit_purchase_category', 'pricing_categories', 'allow_deposit', 'require_deposit', 'deposit_type', 'deposit_amount',
        'enable_multiple_durations', 'durations', 'active_duration_minutes']){
        Object.defineProperty(proxy, key, { enumerable: true, get(){ return vm[key] }, set(v){ vm[key] = v } })
      }
      return proxy
    },
    validateScheduleCustomMessage(){
      if(this.schedule.custom_message_active && !(this.schedule.custom_message || '').trim()){
        this.errs.schedule_custom_message = 'Add a message before enabling, or turn the toggle off'
        this.$notify({ type: 'warning', message: 'Add a message before enabling', timeout: 3000 })
        return false
      }
      this.errs.schedule_custom_message = ''
      return true
    },
    syncEscListener(){
      if(this.modals.create_slot || this.slotToolsOpen){
        document.addEventListener('keydown', this._onEscKey)
      } else {
        document.removeEventListener('keydown', this._onEscKey)
      }
    },
    closeSlotDrawer(){
      this.modals.create_slot = false
      this.slotDrawerView = 'main'
    },
    resetSlotDrawerState(){
      this.slotDrawerView = 'main'
      this.slotSections = { details: true, booking: false, display: false, message: false, resource: false, blocking: false, pricing: false }
    },
    exitPricingView(){
      if(this.$refs.slotPricingEditor && !this.$refs.slotPricingEditor.validate()) return
      this.slotDrawerView = 'main'
    },
    validateSelectedSlotPricing(){
      const result = validateSlotPricing({ enabled: !!this.selectedSlot.is_custom_pricing_enabled, categories: this.selectedSlot.pricing_categories })
      if(!result.valid){
        this.slotDrawerView = 'pricing'
        this.$nextTick(() => { if(this.$refs.slotPricingEditor) this.$refs.slotPricingEditor.validate() })
      }
      return result.valid
    },
    setSlotPeriod(field, list, id){
      this.$set(this.selectedSlot, field, _.find(list, { id: id }))
    },
    hasAllDayEvents() {
      const calendarApi = this.$refs.calendar.getApi();
      const events = calendarApi.getEvents();
      return events.some(event => event.allDay);
    },

    updateAllDaySlotVisibility() {
      const calendarApi = this.$refs.calendar.getApi();
      const hasAllDay = this.hasAllDayEvents();
      calendarApi.setOption('allDaySlot', hasAllDay);
      if (hasAllDay) {
        calendarApi.setOption('allDayText', this.all_day_text || 'All day');
      }
    },
    handleAllDayToggle() {
      if (this.is_all_day) {
        // When switching to all day, clear the time components but keep the dates
        if (this.selectedSlot.start) {
          let startDate = new Date(this.selectedSlot.start);
          startDate.setHours(0, 0, 0, 0);
          this.selectedSlot.start = startDate;
        }
        if (this.selectedSlot.end) {
          let endDate = new Date(this.selectedSlot.end);
          endDate.setHours(23, 59, 59, 999);
          this.selectedSlot.end = endDate;
        }
      }
      this.j++;
    },
    onCategoryChanged(data) {
      this.selectedSlot.resource_category_id = data.categoryId;
    },
    onCategoryChangedSchedule(data){
      this.schedule.resource_category_id = data.categoryId;
    },
    adjustDate(day, date, type) {
      let currentDate = moment(date);
      const currentDay = currentDate.day();
      let diff = day - currentDay;

      if (type === 0) {
        const newStartDate = currentDate.clone().add(diff, 'days');
        this.selectedSlot.start = newStartDate.toDate();
        this.selectedSlot.start_reference = this.selectedSlot.start;

        if (moment(this.selectedSlot.start).isAfter(moment(this.selectedSlot.end))) {
          this.selectedSlot.end = newStartDate.clone().add(7, 'days').toDate();
        } else {
          const maxEndDate = newStartDate.clone().add(7, 'days');
          if (moment(this.selectedSlot.end).isAfter(maxEndDate)) {
            this.selectedSlot.end = moment(this.selectedSlot.end).clone().subtract(8, 'days').toDate();
          }
        }
        this.selectedSlot.end_reference = this.selectedSlot.end;
      } else {
        const newEndDate = currentDate.clone().add(diff, 'days');
        this.selectedSlot.end = newEndDate.toDate();

        if (moment(this.selectedSlot.end).isBefore(moment(this.selectedSlot.start))) {
          this.selectedSlot.end = moment(this.selectedSlot.end).clone().add(7, 'days').toDate();
        }  else {
          const maxEndDate = moment(this.selectedSlot.start).clone().add(7, 'days');
          if (moment(this.selectedSlot.end).isAfter(maxEndDate)) {
            this.selectedSlot.end = moment(this.selectedSlot.end).clone().subtract(7, 'days').toDate();
          }
        }
        this.selectedSlot.end_reference = this.selectedSlot.end;
      }
    },
    handleSelectRuS(item){
      this.schedule.email = item.email
      this.schedule.company_user_id = item.id
      this.schedule.first_name = item.first_name
      this.schedule.last_name = item.last_name
      this.schedule.resource_assignee_object = { first_name: item.first_name, last_name: item.last_name, id: item.id, email: item.email }
    },
    handleSelectRu(item){
      this.selectedSlot.email = item.email
      this.selectedSlot.company_user_id = item.id
      this.selectedSlot.first_name = item.first_name
      this.selectedSlot.last_name = item.last_name
      this.selectedSlot.resource_assignee_object = { first_name: item.first_name, last_name: item.last_name, id: item.id, email: item.email }
    },
    async querySearchCu(queryString, cb) {
      //make API call to /customers with queryString as filter
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/company-users?count=10000000&autocomplete=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.company_users){
            suggestions.push({
              value: JSON.stringify(response.data.company_users[n]),
              email: response.data.company_users[n].email,
              id: response.data.company_users[n].id,
              first_name: response.data.company_users[n].first_name,
              last_name: response.data.company_users[n].last_name
            })
          }
          const results = suggestions;
          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    toggleAnonymousResource(item){
      if(item.anonymous_resource){
        item.resource_assignee_object = null
        item.company_user_id = null
      }
    },
    prepopulateCustomPricingForGame(){
      let game = this.getGameObj(this.selectedGame)[0]
      this.custom_pricing_type = {id: game.pricing_type_id}
      this.cumulative_category_pricing = game.cumulative_category_pricing
      this.allow_deposit = game.allow_deposit
      this.require_deposit = game.require_deposit
      this.deposit_amount = game.deposit_amount
      this.deposit_type = {id: game.deposit_type}
      this.hide_pricing_rate = game.hide_pricing_rate
      this.limit_purchase_category = game.limit_purchase_category
      this.custom_pricing_categories = this.getCategories(JSON.parse(game.game_pricing))
    },
    async copyScheduleTemplate(item, event){
      event.preventDefault()

      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/schedules/' + item.id

      let data = {}

      this.loading = true
      this.axios.post(url, data, config)
        .then(response => {
          this.$router.push({ path: '/bookings/schedules/edit', query: { id:  response.data }})
          this.showDialog({ variant: 'success', title: 'Success', message: 'Schedule has been copied over' })
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status === 500){
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    //Multiple durations: a template's flat category list splits into the default set and one set per duration
    hydrateSlotPricing(slotRow){
      const all = this.getCategories(JSON.parse(slotRow.custom_pricing || '[]'))
      let apiDurations = []
      try { apiDurations = JSON.parse(slotRow.durations || '[]') } catch (e) { apiDurations = [] }
      const split = splitCategoriesByDuration(all, apiDurations)
      const durations = apiDurations.map(d => {
        const isDefault = Number(d.is_default) === 1
        return {
          duration_minutes: Number(d.duration_minutes),
          is_default: isDefault,
          position: Number(d.position) || 0,
          pricing_categories: isDefault ? [] : (split.byMinutes.get(Number(d.duration_minutes)) || [])
        }
      })
      return {
        pricing_categories: split.defaultCategories,
        enable_multiple_durations: Boolean(slotRow.enable_multiple_durations),
        durations,
        active_duration_minutes: null
      }
    },
    getCategories(items){
      const groupedArray = [];

      items.forEach(item => {
        const { category_id, category, minimum_participants, maximum_participants, default_participants, game_duration_id } = item;

        // Find if the category_id already exists in groupedArray
        let group = groupedArray.find(g => g.category_id === category_id);

        if (!group) {
          // If it doesn't exist, create a new group
          group = {
            category_id: category_id,
            category: category,
            minimum_participants: minimum_participants,
            maximum_participants: maximum_participants,
            default_participants: default_participants,
            game_duration_id: game_duration_id === undefined ? null : game_duration_id,
            pricing: []
          };
          groupedArray.push(group);
        }

        group.pricing.push(item);
      });
      return groupedArray;
    },
    validateTime(time, reference){
      if(!time){
        return
      }
      let today = new Date()
      if(reference){
        today = new Date(reference)
      }
      time.setMonth(today.getMonth(), today.getDate())
    },
    disabledDates(time) {
      let date = new Date();
      let previousDate = date.setDate(date.getDate() - 1);
      return time.getTime() < previousDate;
    },
    bulkUpdate(){
      this.bulk_update_settings = !this.bulk_update_settings
      this.help_generate = false
      this.copy_days = false
      this.resetSlotToolsState()
      this.applicableDays = [true, true, true, true, true, true, true]
      this.bulk_time_range = false
      this.schedule.min_booking_period = {id: 1, label: 'hour(s)'}
      this.schedule.min_booking_value = 1
      this.schedule.max_booking_period = {id: 2, label: 'month(s)'}
      this.schedule.max_booking_value = 6
      this.schedule.has_external_link = false
      this.schedule.enable_autoblock = true
      this.schedule.block_status = {id: 1, name: 'Blocked', label: 'blocked'}
      this.schedule.resource_count = 1
      this.schedule.slot_text = ''
      this.schedule.external_link = ''
      this.$set(this.schedule, 'custom_message', '')
      this.$set(this.schedule, 'custom_message_display', 'text')
      this.$set(this.schedule, 'custom_message_active', false)
      this.errs.schedule_custom_message = ''
      this.schedule.status = {id: 0, name: 'Available', label: 'available'}
      this.schedule.anonymous_resource = true
      this.schedule.label = 'Anonymous'
      this.schedule.label_error = ''
      this.schedule.staff_error = ''
      this.schedule.email = null
      this.schedule.company_user_id = null
      this.schedule.supported_event_count = 1
      this.schedule.apply_to_all_events = Boolean(this.schedule.apply_to_all_events)
      this.schedule.include_start_end_time_in_blocking = Boolean(this.schedule.include_start_end_time_in_blocking)
    },
    helpGenerate(){
      this.help_generate = !this.help_generate
      this.bulk_update_settings = false
      this.copy_days = false
      this.resetSlotToolsState()
      this.applicableDays = [false, false, false, false, true, true, true]
      this.schedule.min_booking_period = {id: 1, label: 'hour(s)'}
      this.schedule.min_booking_value = 1
      this.schedule.max_booking_period = {id: 2, label: 'month(s)'}
      this.schedule.max_booking_value = 6
      this.schedule.block_status = {id: 1, name: 'Blocked', label: 'blocked'}
      this.schedule.resource_count = 1
      this.schedule.enable_autoblock = true
      this.schedule.has_external_link = false
      this.schedule.slot_text = ''
      this.schedule.external_link = ''
      this.$set(this.schedule, 'custom_message', '')
      this.$set(this.schedule, 'custom_message_display', 'text')
      this.$set(this.schedule, 'custom_message_active', false)
      this.errs.schedule_custom_message = ''
      if(this.schedule.type.id === 1){
        this.schedule.slot_duration = 480
        this.schedule.gap_duration = 0
      }
      this.schedule.status = {id: 0, name: 'Available', label: 'available'}
      this.schedule.anonymous_resource = true
      this.schedule.label = 'Anonymous'
      this.schedule.email = null
      this.schedule.company_user_id = null
      this.schedule.supported_event_count = 1
      this.schedule.apply_to_all_events = Boolean(this.schedule.apply_to_all_events)
      this.schedule.include_start_end_time_in_blocking = Boolean(this.schedule.include_start_end_time_in_blocking)
      this.schedule.resource_category_id = null
    },
    activateSchedulePrompt(action){
      let html = ''
      if(this.schedule.type.id === 0 && action === 'deactivate'){
        html = 'Deactivating the schedule will remove all future unbooked slots'
      }
      else if (this.schedule.type.id === 0 && action === 'activate'){
        html = 'Activating the schedule will create live booking slots for the valid schedule period'
      }
      else if (this.schedule.type.id === 1 && action === 'deactivate'){
        html = 'Deactivating the schedule will remove all future resource slots'
      }
      else if (this.schedule.type.id === 1 && action === 'activate'){
        html = 'Activating the schedule will create live resource slots for the valid schedule period'
      }
      this.showDialog({
        variant: 'warning',
        title: 'Are you sure?',
        message: html,
        showCancel: true,
        confirmText: 'Continue',
        confirmVariant: 'primary',
        onConfirm: () => {
          if(action === 'activate' && this.schedule.type.id === 0){
            this.checkFutureSlots('activate')
          } else {
            this.activateSchedule(action, this.schedule);
          }
        }
      })

    },
    async activateSchedule(action, item){
      this.loading = true
      let time = new Date()
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let groupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/schedules/' + item.id + '/activate'

      let data = {
        active:  action === 'activate' ? 1 : 0,
        ...buildFutureSlotFlags(this.future_slots),
        time: time.getFullYear() + '-' + (time.getMonth()+1) + '-' + time.getDate(),
      }

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.future_slots = false
          this.showDialog({ variant: 'success', title: 'Success', message: `Schedule has been ` + action + `d` })
          this.getSchedule()
          this.startStatusPolling()

        }).catch((err) => {
        console.log(err)
        this.loading = false
        if(err.response.status == 401){
          this.$router.push('/forbidden')
        } else if (err.response.status === 500){
          this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
        }
      })
    },
    onAutoUnblockInput(value){
      this.j++
      if(value) this.autoUnblockTurnedOn = true
    },
    // Warn only when staff switched auto-unblock on during this visit and a slot
    // still has it on when the schedule is saved.
    needsAutoUnblockWarning(){
      if(!this.autoUnblockTurnedOn || this.schedule.type.id !== 1) return false
      return this.$refs.calendar.getApi().getEvents()
        .some(e => e._def.extendedProps.slotInfo && e._def.extendedProps.slotInfo.enable_auto_unblock)
    },
    updateSchedulePrompt(autoUnblockConfirmed = false){
      if(this.validateScheduleFields()){
        return
      }
      if(!autoUnblockConfirmed && this.needsAutoUnblockWarning()){
        this.showDialog({ ...AUTO_UNBLOCK_WARNING, showCancel: true, onConfirm: () => this.updateSchedulePrompt(true) })
        return
      }
      if(this.schedule.active === 1 && this.schedule.type.id === 0){
        this.checkFutureSlots()
      } else {
        this.updateSchedule()
      }
    },
    getAutoBlockingResourceSlots(){
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      let blocking_events = []
      for(let n in events){
        const slotInfo = events[n]._def.extendedProps.slotInfo
        if(slotInfo && slotInfo.enable_autoblock){
          let startTime, endTime;
          if(events[n].allDay || !events[n].end){
            // For all-day events, use start of day to end of day
            startTime = '0:0';
            endTime = '23:59';
          } else {
            startTime = events[n].start.getHours() + ':' + events[n].start.getMinutes();
            endTime = events[n].end.getHours() + ':' + events[n].end.getMinutes();
          }
          blocking_events.push({
            start_time: startTime,
            end_time: endTime,
            resource_count: slotInfo.resource_count
          })
        }
      }
      return JSON.stringify(blocking_events)
    },
    async checkFutureSlots(source){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let dt = new Date()
      let today = dt.getFullYear() + '-' +  ('0' + (dt.getMonth()+1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)

      let gameIds = []
      for(let n in this.schedule.games){
        gameIds.push(this.schedule.games[n].id)
      }

      //autoblocking
      let resources = this.getAutoBlockingResourceSlots()

      let sd = this.schedule.start_date ? moment(this.schedule.start_date, 'YYYY-MM-DD') : moment()
      let ed =  this.schedule.end_date ? moment(this.schedule.end_date, 'YYYY-MM-DD') : moment()

      if(this.schedule.duration_type.id === 1){
        ed = sd.clone().add(365, 'days');
      }

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/schedules/check-future-slots'

      this.slot_creation_source = source === 'activate' ? 1 : 0
      this.loading = true
      let data = {
          today: today,
          start_date: sd.format('YYYY-MM-DD'),
          end_date: ed.format('YYYY-MM-DD'),
          games: gameIds,
          resources: resources
        }

      this.axios.post(url, data, config)
        .then(response => {
          if(!hasFutureSlotConflicts(response.data)){
            // Keep the loader up: the run turns it off when it finishes
            if(source === 'activate') {
              this.activateSchedule('activate', this.schedule)
            } else {
              this.updateSchedule()
            }
            return
          }
          this.future_slots = buildFutureSlotRows(response.data)
          this.has_insufficient_resource_slots = response.data.insufficient_resources > 0 ? 1 : 0
          this.loading = false
          this.modals.future_slots = true
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status === 500){
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })

    },
    getErrorMessage(err, fallback = 'Something went wrong') {
      const raw = err.response?.data
      let parsed = raw
      if (typeof raw === 'string') {
        try { parsed = JSON.parse(raw) } catch (e) { parsed = { error: raw } }
      }
      return parsed?.error || fallback
    },
    deleteSchedule() {
      this.showDialog({
        variant: 'warning',
        title: 'Are you sure?',
        message: `The schedule will be permanently deleted`,
        showCancel: true,
        confirmText: 'Yes, delete it!',
        confirmVariant: 'danger',
        onConfirm: () => {
          this.delete();
        }
      })
    },
    async delete(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules/' + this.schedule.id

      this.axios.delete(url, config)
        .then(response => {
          this.$notify({ type: 'success', message: 'Schedule has been deleted.', icon: 'tim-icons icon-check-2' })
          this.$router.push('/bookings/schedules')
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response?.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          }
        })
    },
    validateHelperFields(){
      if(isNaN(this.schedule.slot_duration) || this.schedule.slot_duration <= 0){
        this.schedule.slot_duration = 1
      } else if (this.schedule.slot_duration > 1440){
        this.schedule.slot_duration = 1440
      }
      if(isNaN(this.schedule.gap_duration) || this.schedule.gap_duration < 0){
        this.schedule.gap_duration = 0
      } else if (this.schedule.gap_duration > 1440){
        this.schedule.gap_duration = 1440
      }
      this.j++
    },
    clearSlots(){
      const calendarApi = this.$refs.calendar.getApi();
      const selected = this.selectedDayIndices()
      if(selected.length === 0){
        this.showDialog({ variant: 'warning', title: 'No days selected', message: 'Select at least one day to clear.' })
        return
      }
      const scope = this.rangeScopeText(selected)
      const hasSlots = calendarApi.getEvents().some(evt => slotStartsInRange(evt.start, selected, this.start_time, this.end_time))
      if(!hasSlots){
        this.showDialog({ variant: 'info', title: 'Nothing to clear', message: 'No slots start ' + scope + '.' })
        return
      }
      this.showDialog({
        variant: 'warning',
        title: 'Clear slots in range?',
        message: 'Slots starting ' + scope + ' will be removed. The change is kept when you save the schedule.',
        showCancel: true,
        confirmText: 'Clear slots',
        confirmVariant: 'danger',
        onConfirm: () => { this.clearSlotsInRange(selected) }
      })
    },
    clearSlotsInRange(selected){
      const calendarApi = this.$refs.calendar.getApi();
      const targets = calendarApi.getEvents().filter(evt => slotStartsInRange(evt.start, selected, this.start_time, this.end_time))
      this.removeSlotEvents(targets)
      const kept = calendarApi.getEvents().filter(evt => selected.includes(dayIndex(evt.start))).length
      let message = targets.length === 1 ? 'Removed 1 slot.' : 'Removed ' + targets.length + ' slots.'
      if(kept === 1){
        message += ' 1 slot not in this range was kept.'
      } else if(kept > 1){
        message += ' ' + kept + ' slots not in this range were kept.'
      }
      this.$notify({ type: 'success', message: message, timeout: 3000 })
    },
    copyDay(){
      this.copy_days = true
      this.help_generate = false
      this.bulk_update_settings = false
      this.resetSlotToolsState()
      this.copySourceDay = 0
      this.copyMode = 'replace'
      this.applicableDays = [false, false, false, false, false, false, false]
    },
    onCopySourceChange(index){
      this.copySourceDay = index
      this.$set(this.applicableDays, index, false)
    },
    copySlots(){
      const calendarApi = this.$refs.calendar.getApi();
      const source = this.copySourceDay
      const targets = this.selectedDayIndices().filter(i => i !== source)
      if(targets.length === 0){
        this.showDialog({ variant: 'warning', title: 'No days selected', message: 'Select at least one day to copy to.' })
        return
      }
      const events = calendarApi.getEvents()
      if(!events.some(evt => dayIndex(evt.start) === source)){
        this.showDialog({ variant: 'warning', title: 'Nothing to copy', message: 'There are no slots on ' + DAY_NAMES[source] + ' to copy.' })
        return
      }
      if(this.copyMode === 'replace'){
        const occupied = targets.filter(i => events.some(evt => dayIndex(evt.start) === i))
        if(occupied.length > 0){
          this.showDialog({
            variant: 'warning',
            title: 'Replace slots?',
            message: 'Existing slots on ' + formatDayList(occupied) + ' will be replaced with the slots from ' + DAY_NAMES[source] + '. The change is kept when you save the schedule.',
            showCancel: true,
            confirmText: 'Replace slots',
            confirmVariant: 'danger',
            onConfirm: () => { this.applyDayCopy(source, targets) }
          })
          return
        }
      }
      this.applyDayCopy(source, targets)
    },
    applyDayCopy(source, targets){
      const calendarApi = this.$refs.calendar.getApi();
      if(this.copyMode === 'replace'){
        this.removeSlotsOnDays(targets)
      }
      const sourceEvents = calendarApi.getEvents().filter(evt => dayIndex(evt.start) === source)
      const sourceById = new Map(sourceEvents.map(evt => [String(evt.id), evt]))
      const { copies, skipped } = buildDayCopies(
        sourceEvents.map(evt => ({ key: String(evt.id), start: evt.start, end: evt.end, priority: evt.extendedProps.slotInfo.priority })),
        source,
        targets,
        calendarApi.view.activeEnd
      )

      copies.forEach(copy => {
        const src = sourceById.get(copy.key)
        // Deep copy so later edits or bulk updates never touch the source slot
        const slotInfo = _.cloneDeep(src.extendedProps.slotInfo)
        slotInfo.id = uuidv4()
        slotInfo.start = copy.start
        slotInfo.end = copy.end
        slotInfo.start_reference = copy.start
        slotInfo.end_reference = copy.end
        slotInfo.start_day = _.find(this.days_of_week, { id: copy.start.getDay() })
        slotInfo.end_day = _.find(this.days_of_week, { id: copy.end.getDay() })
        slotInfo.editing = false

        const event = {
          id: slotInfo.id,
          title: src.title,
          start: copy.start,
          end: copy.end,
          allDay: src.allDay,
          backgroundColor: src.backgroundColor,
          slotInfo: slotInfo
        }
        if(src.textColor){
          event.textColor = src.textColor
        }
        calendarApi.addEvent(event)
        // Copies go in priority order, so each keeps its priority and overlapping existing slots move down
        this.adjustPriorities(slotInfo)
      })

      if(copies.length > 0){
        this.expandTimeLineRange(copies[0].start, copies[0].end)
      }
      this.updateAllDaySlotVisibility();
      this.closeSlotTools()

      if(skipped > 0){
        const copiedText = copies.length === 1 ? '1 slot was copied.' : copies.length + ' slots were copied.'
        const skippedText = skipped === 1
          ? '1 overnight slot was not copied because it would end at or after midnight on Sunday.'
          : skipped + ' overnight slots were not copied because they would end at or after midnight on Sunday.'
        this.showDialog({ variant: 'warning', title: 'Some slots were not copied', message: copiedText + ' ' + skippedText })
      }
    },
    rangeScopeText(selected){
      return formatRangeScope(
        moment(this.start_time).format(this.picker_time_format),
        moment(this.end_time).format(this.picker_time_format),
        selected
      )
    },
    selectedDayIndices(){
      return this.applicableDays
        .map((checked, i) => checked ? i : -1)
        .filter(i => i >= 0)
    },
    removeSlotsOnDays(indices){
      const calendarApi = this.$refs.calendar.getApi();
      this.removeSlotEvents(calendarApi.getEvents().filter(evt => indices.includes(dayIndex(evt.start))))
    },
    removeSlotEvents(targets){
      const calendarApi = this.$refs.calendar.getApi();
      targets.forEach(evt => {
        const slotInfo = (evt.extendedProps && evt.extendedProps.slotInfo) || {}
        const removed = { id: evt.id, start: evt.start, end: evt.end, priority: slotInfo.priority }
        evt.remove()
        this.adjustPrioritiesAfterDelete(calendarApi, removed)
      })
      this.refreshTimelineAfterRemoval()
    },
    refreshTimelineAfterRemoval(){
      const calendarApi = this.$refs.calendar.getApi();
      const remaining = calendarApi.getEvents()
      if(remaining.length === 0){
        // expandTimeLineRange cannot run on an empty calendar
        calendarApi.setOption('slotMinTime', '09:00:00')
        calendarApi.setOption('slotMaxTime', '20:00:00')
      } else {
        this.expandTimeLineRange(remaining[0].start, remaining[0].end)
      }
      this.updateAllDaySlotVisibility();
    },
    bulkUpdateSlots(){
      if(!this.validateResourceSlot(this.schedule)){
        this.j++
        return
      }
      if(!this.validateScheduleCustomMessage()){
        return
      }
      if(this.schedule.type.id === 0 && !this.validateToolsPricing()){
        return
      }
      const selected = this.selectedDayIndices()
      if(selected.length === 0){
        this.showDialog({ variant: 'warning', title: 'No days selected', message: 'Select at least one day to update.' })
        return
      }
      let updated = 0
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      for(let n in events){
        const inScope = this.bulk_time_range
          ? slotStartsInRange(events[n].start, selected, this.start_time, this.end_time)
          : selected.includes(dayIndex(events[n].start))
        if(inScope){
          updated++
          //status
          if(this.schedule.status.id === 0){
            events[n].setProp('backgroundColor', "#1d8cf8")
          } else if(this.schedule.status.id === 2){
            events[n].setProp("backgroundColor", "#ff8d72")
          } else if(this.schedule.status.id === 3){
            events[n].setProp("backgroundColor", "#FFD600")
            events[n].setProp("textColor", "#1E1E2F")
          }
          events[n]._def.extendedProps.slotInfo.status = this.schedule.status

          //min/max
          events[n]._def.extendedProps.slotInfo.min_booking_value = this.schedule.min_booking_value
          events[n]._def.extendedProps.slotInfo.min_booking_period = this.schedule.min_booking_period
          events[n]._def.extendedProps.slotInfo.allow_late_booking = this.schedule.allow_late_booking
          events[n]._def.extendedProps.slotInfo.hide_past_min_notice = this.schedule.hide_past_min_notice
          events[n]._def.extendedProps.slotInfo.request_past_min_notice = this.schedule.request_past_min_notice
          events[n]._def.extendedProps.slotInfo.max_booking_value = this.schedule.max_booking_value
          events[n]._def.extendedProps.slotInfo.max_booking_period = this.schedule.max_booking_period

          //call to book
          events[n]._def.extendedProps.slotInfo.has_external_link = this.schedule.has_external_link
          events[n]._def.extendedProps.slotInfo.external_link = this.schedule.external_link
          events[n]._def.extendedProps.slotInfo.slot_text = this.schedule.slot_text
          this.$set(events[n]._def.extendedProps.slotInfo, 'custom_message', this.schedule.custom_message || '')
          this.$set(events[n]._def.extendedProps.slotInfo, 'custom_message_display', this.schedule.custom_message_display || 'text')
          this.$set(events[n]._def.extendedProps.slotInfo, 'custom_message_active', Boolean(this.schedule.custom_message_active))

          //resources
          events[n]._def.extendedProps.slotInfo.resource_count = this.schedule.resource_count
          events[n]._def.extendedProps.slotInfo.enable_autoblock = this.schedule.enable_autoblock
          events[n]._def.extendedProps.slotInfo.block_status = this.schedule.block_status
          events[n]._def.extendedProps.slotInfo.anonymous_resource = this.schedule.anonymous_resource
          events[n]._def.extendedProps.slotInfo.label = this.schedule.label
          events[n]._def.extendedProps.slotInfo.email = this.schedule.email
          events[n]._def.extendedProps.slotInfo.resource_assignee_object = this.schedule.resource_assignee_object
          events[n]._def.extendedProps.slotInfo.company_user_id = this.schedule.company_user_id
          events[n]._def.extendedProps.slotInfo.first_name = this.schedule.first_name
          events[n]._def.extendedProps.slotInfo.last_name = this.schedule.last_name
          events[n]._def.extendedProps.slotInfo.supported_event_count = this.schedule.supported_event_count

          let slotInfo = events[n]._def.extendedProps.slotInfo
          if(this.schedule.status.id === 0){
            events[n].setProp('title', this.schedule.type.id === 0 ? 'Available' :
              slotInfo.company_user_id ? slotInfo.first_name + ' ' + slotInfo.last_name + ' (' + slotInfo.priority + ')' :
                slotInfo.label + ' (' + slotInfo.priority + ')')
          } else if(this.schedule.status.id === 2){
            events[n].setProp("title", "Call to book")
          } else if(this.schedule.status.id === 3){
            events[n].setProp("title", "Requestable")
          }

          events[n]._def.extendedProps.slotInfo.include_start_end_time_in_blocking = this.schedule.include_start_end_time_in_blocking
          events[n]._def.extendedProps.slotInfo.apply_to_all_events = this.schedule.apply_to_all_events
          events[n]._def.extendedProps.slotInfo.linked_games = this.schedule.linked_games
          events[n]._def.extendedProps.slotInfo.resource_category_id = this.schedule.resource_category_id
          events[n]._def.extendedProps.slotInfo.enable_auto_unblock = this.schedule.enable_auto_unblock
          events[n]._def.extendedProps.slotInfo.exclude_call_to_book_from_auto_unblock = this.schedule.exclude_call_to_book_from_auto_unblock
          events[n]._def.extendedProps.slotInfo.saturate_on_first_assignment = this.schedule.saturate_on_first_assignment

          //pricing
          events[n]._def.extendedProps.slotInfo.is_custom_pricing_enabled = this.is_custom_pricing_enabled
          events[n]._def.extendedProps.slotInfo.is_public_booking = this.is_public_booking
          events[n]._def.extendedProps.slotInfo.pricing_type = {id: this.pricing_type.id}
          events[n]._def.extendedProps.slotInfo.cumulative_category_pricing = this.cumulative_category_pricing
          events[n]._def.extendedProps.slotInfo.hide_pricing_rate = this.hide_pricing_rate
          events[n]._def.extendedProps.slotInfo.limit_purchase_category = this.limit_purchase_category
          events[n]._def.extendedProps.slotInfo.allow_deposit = this.allow_deposit
          events[n]._def.extendedProps.slotInfo.deposit_type = {id: this.deposit_type.id}
          events[n]._def.extendedProps.slotInfo.deposit_amount = this.deposit_amount
          events[n]._def.extendedProps.slotInfo.require_deposit = this.require_deposit
          events[n]._def.extendedProps.slotInfo.pricing_categories = JSON.parse(JSON.stringify(this.pricing_categories))
          events[n]._def.extendedProps.slotInfo.enable_multiple_durations = this.enable_multiple_durations
          events[n]._def.extendedProps.slotInfo.durations = JSON.parse(JSON.stringify(this.durations || []))
          events[n]._def.extendedProps.slotInfo.active_duration_minutes = null
        }
      }
      if(updated === 0){
        this.showDialog(this.bulk_time_range
          ? { variant: 'warning', title: 'No slots matched', message: 'No slots start ' + this.rangeScopeText(selected) + '.' }
          : { variant: 'warning', title: 'Nothing to update', message: 'There are no slots on ' + formatDayList(selected) + '.' })
        return
      }
      this.$notify({ type: 'success', message: updated === 1 ? 'Updated 1 slot.' : 'Updated ' + updated + ' slots.', timeout: 3000 })
    },
    generateSlots(){
      if(!this.validateResourceSlot(this.schedule)){
        this.j++
        return
      }
      if(!this.validateScheduleCustomMessage()){
        return
      }
      if(this.schedule.type.id === 0 && !this.validateToolsPricing()){
        return
      }
      let calendarApi = this.$refs.calendar.getApi();
      let today = new Date()
      let day = today.getDay()
      let day_diff = 0
      let dayStart = new Date()
      let dayEnd = new Date()
      let slotStart = new Date()
      let slotEnd = new Date()
      let event = {}
      let selectedSlot = {}

      let count = 0
      let skipped = 0
      const weekEnd = calendarApi.view.activeEnd
      const overnight = crossesMidnight(this.start_time, this.end_time)
      // FullCalendar renders synchronously on every addEvent; pause rendering
      // for the whole loop so a dense schedule renders once, not once per slot.
      calendarApi.batchRendering(() => {
      for(let n in this.applicableDays){
        if(this.applicableDays[n] === true){
          today = new Date()
          day = today.getDay()

          day_diff = 0
          dayStart = new Date()
          dayEnd = new Date()
          slotStart = new Date()
          slotEnd = new Date()

          if(day === 0){
            dayStart.setDate(dayStart.getDate() - 7)
            dayEnd.setDate(dayEnd.getDate() - 7)
            slotStart.setDate(slotStart.getDate() - 7)
            slotEnd.setDate(slotEnd.getDate() - 7)
          }
          day_diff = day - (parseInt(n) + 1)
          dayStart.setDate(dayStart.getDate() - day_diff)
          dayStart.setHours(this.start_time.getHours())
          dayStart.setMinutes(this.start_time.getMinutes(), 0, 0)

          dayEnd.setDate(dayEnd.getDate() - day_diff)
          dayEnd.setHours(this.end_time.getHours())
          dayEnd.setMinutes(this.end_time.getMinutes(), 0, 0)
          if(overnight){
            dayEnd.setDate(dayEnd.getDate() + 1)
          }

          slotStart.setFullYear(dayStart.getFullYear())
          slotStart.setMonth(dayStart.getMonth(), dayStart.getDate())
          slotStart.setHours(dayStart.getHours())
          slotStart.setMinutes(dayStart.getMinutes(), 0, 0)
          slotEnd.setFullYear(dayStart.getFullYear())
          slotEnd.setMonth(dayStart.getMonth(), dayStart.getDate())
          slotEnd.setHours(dayStart.getHours())
          slotEnd.setMinutes(dayStart.getMinutes() + parseInt(this.schedule.slot_duration), 0, 0)

          while (slotEnd <= dayEnd){

            const placed = placeInWeek(slotStart, slotEnd, weekEnd)
            if(!placed){
              skipped++
            } else {
              let sdt = placed.start
              let edt = placed.end
              selectedSlot = {
                start: sdt,
                end: edt,
                start_reference: sdt,
                end_reference: edt,
                status: this.schedule.status,
                min_booking_period: this.schedule.min_booking_period,
                min_booking_value: this.schedule.min_booking_value,
                hide_past_min_notice: this.schedule.hide_past_min_notice,
                request_past_min_notice: this.schedule.request_past_min_notice,
                allow_late_booking: this.schedule.allow_late_booking,
                max_booking_period: this.schedule.max_booking_period,
                max_booking_value: this.schedule.max_booking_value,
                slot_text: this.schedule.slot_text,
                custom_message: this.schedule.custom_message || '',
                custom_message_display: this.schedule.custom_message_display || 'text',
                custom_message_active: Boolean(this.schedule.custom_message_active),
                has_external_link: this.schedule.has_external_link,
                external_link: this.schedule.external_link,
                editing: false,
                id: uuidv4(),
                start_day: _.find(this.days_of_week, {id: sdt.getDay()}),
                end_day: _.find(this.days_of_week, {id: edt.getDay()}),
                resource_count: this.schedule.resource_count,
                enable_autoblock: this.schedule.enable_autoblock,
                block_status: this.schedule.block_status,
                is_custom_pricing_enabled: this.is_custom_pricing_enabled,
                pricing_type: {id: this.pricing_type.id},
                is_public_booking: this.is_public_booking,
                cumulative_category_pricing: this.cumulative_category_pricing,
                hide_pricing_rate: this.hide_pricing_rate,
                limit_purchase_category: this.limit_purchase_category,
                allow_deposit: this.allow_deposit,
                deposit_type: {id: this.deposit_type.id},
                deposit_amount: this.deposit_amount,
                require_deposit: this.require_deposit,
                pricing_categories: JSON.parse(JSON.stringify(this.pricing_categories)),
                enable_multiple_durations: this.enable_multiple_durations,
                durations: JSON.parse(JSON.stringify(this.durations || [])),
                active_duration_minutes: null,
                anonymous_resource: this.schedule.anonymous_resource,
                label: this.schedule.label,
                email: this.schedule.email,
                resource_assignee_object: this.schedule.resource_assignee_object,
                company_user_id: this.schedule.company_user_id,
                first_name: this.schedule.first_name,
                last_name: this.schedule.last_name,
                supported_event_count: this.schedule.supported_event_count,
                include_start_end_time_in_blocking: this.schedule.include_start_end_time_in_blocking,
                apply_to_all_events: this.schedule.apply_to_all_events,
                linked_games: this.schedule.linked_games,
                priority: 1,
                resource_category_id: this.schedule.resource_category_id,
                enable_auto_unblock: this.schedule.enable_auto_unblock,
                exclude_call_to_book_from_auto_unblock: this.schedule.exclude_call_to_book_from_auto_unblock,
                saturate_on_first_assignment: this.schedule.saturate_on_first_assignment
              }
              event = {
                title: this.schedule.type.id === 0 ? 'Available' :
                  selectedSlot.company_user_id ?  selectedSlot.first_name + ' ' +  selectedSlot.last_name +
                    ' (' + selectedSlot.priority + ')':
                    selectedSlot.label + ' (' + selectedSlot.priority + ')',
                start: new Date(sdt),
                end: new Date(edt),
                allDay: false,
                id: selectedSlot.id,
                backgroundColor: "#1d8cf8",
                slotInfo: selectedSlot
              }
              if(selectedSlot.status.id === 0){
                event.title = this.schedule.type.id === 0 ? 'Available' :
                  selectedSlot.company_user_id ?  selectedSlot.first_name + ' ' +  selectedSlot.last_name +
                    ' (' + selectedSlot.priority + ')':
                    selectedSlot.label + ' (' + selectedSlot.priority + ')'
                event.backgroundColor = "#1d8cf8"
              } else if(selectedSlot.status.id === 1){
                event.title = this.schedule.type.id === 0? 'Blocked' : 'Not available'
                event.backgroundColor = "#fd5d93"
              } else if(selectedSlot.status.id === 2){
                event.title = "Call to book"
                event.backgroundColor = "#ff8d72"
              } else if(selectedSlot.status.id === 3){
                event.title = "Requestable"
                event.backgroundColor = "#FFD600"
                event.textColor = "#1E1E2F"
              }
              calendarApi.addEvent(event);
              count++
              this.expandTimeLineRange(sdt, edt)
              this.adjustPriorities(selectedSlot)
            }
            let newSlotStart = new Date(slotEnd);
            newSlotStart.setMinutes(newSlotStart.getMinutes() + parseInt(this.schedule.gap_duration));
            slotStart = newSlotStart;

            let newSlotEnd = new Date(slotStart);
            newSlotEnd.setMinutes(newSlotEnd.getMinutes() + parseInt(this.schedule.slot_duration));
            slotEnd = newSlotEnd;
          }
        }
      }
      })
      if(skipped > 0){
        const createdText = count === 1 ? '1 slot was created.' : count + ' slots were created.'
        const skippedText = skipped === 1
          ? '1 overnight slot was not created because it would end at or after midnight on Sunday.'
          : skipped + ' overnight slots were not created because they would end at or after midnight on Sunday.'
        this.showDialog({ variant: 'warning', title: 'Some slots were not created', message: createdText + ' ' + skippedText })
      } else if(count === 0){
        this.showDialog({ variant: 'warning', title: 'Warning', message: 'No slots were created. Check your settings and try again.' })
      }
    },
    getLatestSlot() {
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      let latestTime = null;

      events.forEach(event => {
        const eventStartTime = new Date(event.start);
        const eventEndTime = new Date(event.end);

        // Extract HH:mm:ss from start and end times
        const startTimeString = eventStartTime.getHours().toString().padStart(2, '0') + ':' +
          eventStartTime.getMinutes().toString().padStart(2, '0') + ':' +
          eventStartTime.getSeconds().toString().padStart(2, '0');

        const endTimeString = eventEndTime.getHours().toString().padStart(2, '0') + ':' +
          eventEndTime.getMinutes().toString().padStart(2, '0') + ':' +
          eventEndTime.getSeconds().toString().padStart(2, '0');

        // Compare extracted times as strings
        if (!latestTime || startTimeString > latestTime) {
          latestTime = startTimeString;
        }

        if (!latestTime || endTimeString > latestTime) {
          latestTime = endTimeString;
        }
      });

      return latestTime;
    },
    getEarliestSlot() {
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      let earliestTime = null;

      events.forEach(event => {
        const eventStartTime = new Date(event.start);
        const eventEndTime = new Date(event.end);

        // Extract HH:mm:ss only (ignoring the date)
        const startTimeString = eventStartTime.toTimeString().split(' ')[0]; // "HH:mm:ss"
        const endTimeString = eventEndTime.toTimeString().split(' ')[0]; // "HH:mm:ss"

        // Compare times as strings (since they are in HH:mm:ss format)
        if (!earliestTime || startTimeString < earliestTime) {
          earliestTime = startTimeString;
        }

        if (!earliestTime || endTimeString < earliestTime) {
          earliestTime = endTimeString;
        }
      });

      return earliestTime;
    },
    expandTimeLineRange(start, end) {
      let calendarApi = this.$refs.calendar.getApi();

      let min_time = moment(start).hours(9).minutes(0).seconds(0);
      let earliestTime = this.getEarliestSlot();

      let [hours, minutes] = earliestTime.split(':').map(Number);

      // Round minutes to the nearest 15-minute interval
      minutes = Math.round(minutes / 15) * 15;

      // Ensure hours and minutes are properly set on the moment object
      let earliestSlot = moment(min_time)
        .hours(hours)
        .minutes(minutes)
        .seconds(0);

      if (moment(start).isBefore(min_time)) {
        let adjustedMinutes = Math.round((parseInt(earliestTime.split(':')[1]) - 30) / 15) * 15;

        if (earliestSlot.hours() === 0 && adjustedMinutes < 0) {
          adjustedMinutes = 0; // Set it to midnight if it would go negative
        }

        earliestSlot.minutes(adjustedMinutes);
        let new_min_time = earliestSlot.format('HH:mm:ss');
        calendarApi.setOption('slotMinTime', new_min_time);
        calendarApi.scrollToTime(new_min_time);
      }
      else if (earliestSlot.isBefore(min_time)) {
        let adjustedMinutes = Math.round((parseInt(earliestTime.split(':')[1]) - 30) / 15) * 15;

        if (earliestSlot.hours() === 0 && adjustedMinutes < 0) {
          adjustedMinutes = 0; // Set it to midnight if it would go negative
        }

        earliestSlot.minutes(adjustedMinutes);
        let new_min_time = earliestSlot.format('HH:mm:ss');

        calendarApi.setOption('slotMinTime', new_min_time);
        calendarApi.scrollToTime(new_min_time);
      }
      else if (min_time.isBefore(earliestSlot)) {
        let new_min_time = min_time.format('HH:mm:ss');
        calendarApi.setOption('slotMinTime', new_min_time);
      }

      let max_time = moment(end).hours(19).minutes(0).seconds(0);
      let latestTime = this.getLatestSlot();
      let latestSlot = moment(max_time)
        .hours(parseInt(latestTime.split(':')[0]))
        .minutes(Math.round(parseInt(latestTime.split(':')[1]) / 15) * 15)
        .seconds(0);


      if (this.isMidnight(latestSlot.toDate())) {
        latestSlot.subtract(1, 'minute');
      }
      if (moment(end).isAfter(max_time)) {
        let new_end_time = latestSlot.format('HH:mm:ss');
        calendarApi.setOption('slotMaxTime', new_end_time);
      }
      else if (latestSlot.isAfter(max_time)) {
        let adjustedMinutesLate = Math.round((parseInt(latestTime.split(':')[1]) + 30) / 15) * 15;
        if (latestSlot.hours() === 0 && adjustedMinutesLate <= 0) {
          adjustedMinutesLate = 0; // Ensure it doesn't go negative
        }

        latestSlot.minutes(adjustedMinutesLate);

        // If the new end time is midnight or later, set it to 11:45 PM
        if (latestSlot.hours() >= 0) {
          latestSlot.hours(23).minutes(59).seconds(0);
        }

        let new_end_time = latestSlot.format('HH:mm:ss');
        calendarApi.setOption('slotMaxTime', new_end_time);
      }
      else if (max_time.isAfter(latestSlot)) {
        let new_end_time = max_time.format('HH:mm:ss');
        calendarApi.setOption('slotMaxTime', new_end_time);
      }
    },
    isMidnight(date) {
      return date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;
    },
    deleteTimeSlot(){
      const calendarApi = this.$refs.calendar.getApi();
      const event = calendarApi.getEventById(this.selectedSlot.id);
      event.remove();
      this.modals.create_slot = false
      this.expandTimeLineRange(event.start, event.end)
      this.adjustPrioritiesAfterDelete(calendarApi, this.selectedSlot)
      this.updateAllDaySlotVisibility();
    },
    adjustPrioritiesAfterDelete(calendarApi, deletedSlot) {
      if (!calendarApi || typeof calendarApi.getEvents !== 'function') {
        console.error('calendarApi is not available');
        return;
      }

      let deletedStart = new Date(deletedSlot.start).getTime();
      let deletedEnd = new Date(deletedSlot.end).getTime();
      let deletedPriority = deletedSlot.priority;
      let deletedId = String(deletedSlot.id);

      let overlappingEvents = [];
      let events = calendarApi.getEvents();

      for (let i = 0; i < events.length; i++) {
        let evt = events[i];
        if (String(evt.id) === deletedId) {
          continue;
        }

        let evtStart = new Date(evt.start).getTime();
        let evtEnd = new Date(evt.end).getTime();

        if (deletedStart < evtEnd && deletedEnd > evtStart) {
          overlappingEvents.push(evt);
        }
      }

      for (let j = 0; j < overlappingEvents.length; j++) {
        let overlapping = overlappingEvents[j];
        let slotInfo = overlapping.extendedProps && overlapping.extendedProps.slotInfo;
        let currentPriority = 9999;

        if (slotInfo && typeof slotInfo.priority === 'number') {
          currentPriority = slotInfo.priority;
        }

        if (currentPriority > deletedPriority) {
          let updatedPriority = currentPriority - 1;

          let updatedSlotInfo = JSON.parse(JSON.stringify(slotInfo));
          updatedSlotInfo.priority = updatedPriority;

          overlapping.setExtendedProp("slotInfo", updatedSlotInfo);

          let originalTitle = overlapping.title || "";
          let updatedTitle = "";

          if (/\(.*?\)/.test(originalTitle)) {
            updatedTitle = originalTitle.replace(/\(.*?\)/, "(" + updatedPriority + ")");
          } else {
            updatedTitle = originalTitle + " (" + updatedPriority + ")";
          }

          overlapping.setProp("title", updatedTitle);
        }
      }
    },
    updateSlotInfo(info){

      let calendarApi = this.$refs.calendar.getApi();
      const event = calendarApi.getEventById(info.event._def.publicId);
      if (!event.start || !event.end) {
        return; // Exit early if dates are null
      }
      event.extendedProps.slotInfo.start = event.start
      event.extendedProps.slotInfo.end = event.end
      this.selectedSlot = event.extendedProps.slotInfo
      this.selectedSlot.start = event.start
      this.selectedSlot.end = event.end

      this.selectedSlot.start_day = _.find(this.days_of_week, {id: event.start.getDay()})
      this.selectedSlot.end_day = _.find(this.days_of_week, {id: event.end.getDay()})

      this.expandTimeLineRange(event.start, event.end)
    },
    getDayOfTheWeek(dt){
      if(!dt){
        return ''
      }
      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      return days[dt.getDay()]
    },
    validateResourceSlot(item){
      let errors = 0
      if(item.anonymous_resource && item.label === ''){
        item.label_error = 'Label cannot be empty'
        errors++
      } else {
        item.label_error = ''
      }
      if(!item.anonymous_resource && !item.email ){
        item.staff_error = 'Assignee cannot be empty'
        errors++
      } else {
        item.staff_error = ''
      }
      if(errors > 0){
        return false
      }
      return true
    },
    validateSlot(slot){
      let error = 0

      if(slot.start == '' || slot.start === null){
        this.errs.start_date_slot = "Start time cannot be empty"
        error++
      } else {
        this.errs.start_date_slot = ''
      }

      let start = moment(slot.start)
      let end = moment(slot.end)
      const isDateSequenceBeforeOrSame = start.isBefore(end) || start.isSame(end)

      if(slot.end == '' || slot.end === null){
        this.errs.end_date_slot = "End time cannot be empty"
        error++
      } else if(!isDateSequenceBeforeOrSame){
        this.errs.end_date_slot = "End time cannot be before start time"
        error++
      } else {
        this.errs.end_date_slot = ''
      }

      if(slot.custom_message_active && !(slot.custom_message || '').trim()){
        this.errs.custom_message = 'Add a message before enabling, or turn the toggle off'
        error++
      } else {
        this.errs.custom_message = ''
      }

      this.j++
      return error > 0 ? false : true
    },
    updateSlot(){
      if(!this.validateResourceSlot(this.selectedSlot)){
        return
      }
      if(!this.validateSlot(this.selectedSlot)){
        return
      }
      if(!this.validateSelectedSlotPricing()){
        return
      }

      this.selectedSlot.is_all_day = this.is_all_day;
      this.selectedSlot.all_day_text = this.all_day_text;

      let calendarApi = this.$refs.calendar.getApi();
      let event = calendarApi.getEventById(this.selectedSlot.id);


      if(this.is_all_day){
        this.handleAllDayToggle()
        event.setAllDay(Boolean(this.is_all_day));
      } else {
        event.setDates(this.selectedSlot.start, this.selectedSlot.end)
      }
      event.setExtendedProp('slotInfo', this.selectedSlot);
      let title = this.schedule.type.id === 0 ? this.selectedSlot.status.name :
        this.selectedSlot.company_user_id ?  this.selectedSlot.first_name + ' ' +  this.selectedSlot.last_name +
          ' (' + this.selectedSlot.priority + ')':
          this.selectedSlot.label + ' (' + this.selectedSlot.priority + ')'
      event.setProp('title', title);

      if(this.selectedSlot.status.id === 0){
        event.setProp('backgroundColor', "#1d8cf8");
      } else if(this.selectedSlot.status.id === 1){
        event.setProp('backgroundColor', "#fd5d93");
      } else if(this.selectedSlot.status.id === 2){
        event.setProp("backgroundColor", "#ff8d72");
      } else if(this.selectedSlot.status.id === 3){
        event.setProp("backgroundColor", "#FFD600");
        event.setProp("textColor", "#1E1E2F");
      }
      this.expandTimeLineRange(this.selectedSlot.start, this.selectedSlot.end)

      const priorityChanged = this.originalSlot && this.selectedSlot.priority !== this.originalSlot.priority;
      const timeChanged = this.originalSlot && (
        new Date(this.selectedSlot.start).getTime() !== new Date(this.originalSlot.start).getTime() ||
        new Date(this.selectedSlot.end).getTime() !== new Date(this.originalSlot.end).getTime()
      );
      if (priorityChanged || timeChanged) {
        this.adjustPriorities(this.selectedSlot)
      }

      this.$nextTick(() => {
        this.updateAllDaySlotVisibility();
      });
      this.modals.create_slot = false
    },
    editSlot(info){
      this.resetSlotDrawerState()
      this.originalSlot = {...info.event._def.extendedProps.slotInfo}
      this.selectedSlot = info.event._def.extendedProps.slotInfo
      let calendarApi = this.$refs.calendar.getApi();
      let overlapCount = this.countOverlappingEvents(calendarApi, this.selectedSlot.start, this.selectedSlot.end, this.selectedSlot.id, false);
      this.priorities = []
      for(let i = 0; i <= overlapCount; i++){
        this.priorities.push(1+i)
      }

      this.selectedSlot.is_custom_pricing_enabled = Boolean(this.selectedSlot.is_custom_pricing_enabled)
      this.selectedSlot.cumulative_category_pricing = Boolean(this.selectedSlot.cumulative_category_pricing)
      this.selectedSlot.allow_deposit = Boolean(this.selectedSlot.allow_deposit)
      this.selectedSlot.hide_pricing_rate = Boolean(this.selectedSlot.hide_pricing_rate)
      this.selectedSlot.limit_purchase_category = Boolean(this.selectedSlot.limit_purchase_category)
      this.selectedSlot.require_deposit = Boolean(this.selectedSlot.require_deposit)
      this.selectedSlot.apply_to_all_events = Boolean(this.selectedSlot.apply_to_all_events)
      this.selectedSlot.include_start_end_time_in_blocking = Boolean(this.selectedSlot.include_start_end_time_in_blocking)
      if(!this.selectedSlot.hasOwnProperty('custom_message')){
        this.$set(this.selectedSlot, 'custom_message', '')
        this.$set(this.selectedSlot, 'custom_message_display', 'text')
        this.$set(this.selectedSlot, 'custom_message_active', false)
      }
      this.is_all_day = Boolean(this.selectedSlot.is_all_day);
      this.all_day_text = this.selectedSlot.all_day_text || 'All day';
      this.errs.start_date_slot = ''
      this.errs.end_date_slot = ''
      this.selectedSlot.editing = true
      this.modals.create_slot = true

    },
    countOverlappingEvents(calendarApi, start, end, selfId = null, includeSelf = false) {
      const newStart = new Date(start).getTime();
      const newEnd = new Date(end).getTime();

      const events = calendarApi.getEvents();

      return events.filter(evt => {
        const evtStart = new Date(evt.start).getTime();
        const evtEnd = new Date(evt.end).getTime();
        const evtId = String(evt.id);
        const isSelf = selfId !== null && evtId === String(selfId);
        const overlaps = newStart < evtEnd && newEnd > evtStart;
        // ✅ Final logic
        if (isSelf && !includeSelf) {
          return false;
        }

        const shouldInclude = overlaps;
        return shouldInclude;
      }).length;
    },
    createSlotSave(){
      if(!this.validateSlot(this.selectedSlot)){
        return
      }
      if(!this.validateSelectedSlotPricing()){
        return
      }
      let calendarApi = this.$refs.calendar.getApi();

      this.selectedSlot.is_all_day = this.is_all_day;
      this.selectedSlot.all_day_text = this.all_day_text;

      let event = {
        title: this.schedule.type.id === 0 ? this.selectedSlot.status.name :
          this.selectedSlot.company_user_id ?  this.selectedSlot.first_name + ' ' +  this.selectedSlot.last_name +
            ' (' + this.selectedSlot.priority + ')':
            this.selectedSlot.label + ' (' + this.selectedSlot.priority + ')',
        start: this.selectedSlot.start,
        end: this.selectedSlot.end,
        allDay: Boolean(this.is_all_day),
        slotInfo: this.selectedSlot,
        backgroundColor: "#1d8cf8",
        id: this.selectedSlot.id
      }
      if(this.selectedSlot.status.id === 1){
        event.backgroundColor = "#fd5d93"
      }
      else if(this.selectedSlot.status.id === 2){
        event.backgroundColor = "#ff8d72"
      }
      else if(this.selectedSlot.status.id === 3){
        event.backgroundColor = "#FFD600"
        event.textColor = "#1E1E2F"
      }
      calendarApi.addEvent(event);
      this.expandTimeLineRange(this.selectedSlot.start, this.selectedSlot.end)
      this.adjustPriorities(this.selectedSlot)

      this.updateAllDaySlotVisibility();

      this.modals.create_slot = false
    },
    adjustPriorities(slot, isEditing = false, originalSlot = null) {
      let calendarApi = this.$refs.calendar.getApi();
      if (!calendarApi || typeof calendarApi.getEvents !== 'function') {
        console.error('calendarApi is not available');
        return;
      }

      const overlappingEvents = this.getOverlappingEvents(
        calendarApi,
        slot.start,
        slot.end,
        slot.id
      );


      const priorityList = this.buildPriorityList(overlappingEvents, slot);

      this.normalizePriorities(priorityList, slot.priority);
    },
    normalizePriorities(priorityList, editedSlotPriority) {
      const others = priorityList
        .filter(item => !item.isEditedSlot)
        .sort((a, b) => a.priority - b.priority);

      let nextConflict = editedSlotPriority;

      for (let i = 0; i < others.length; i++) {
        const item = others[i];
        if (item.priority !== nextConflict) continue;

        const bumpedPriority = item.priority + 1;
        item.priority = bumpedPriority;

        const updatedSlotInfo = {
          ...item.evt.extendedProps.slotInfo,
          priority: bumpedPriority
        };

        item.evt.setExtendedProp("slotInfo", updatedSlotInfo);

        if (this.schedule.type.id !== 0) {
          const originalTitle = item.evt.title || "";
          const updatedTitle = /\(.*?\)/.test(originalTitle)
            ? originalTitle.replace(/\(.*?\)/, `(${bumpedPriority})`)
            : `${originalTitle} (${bumpedPriority})`;

          item.evt.setProp("title", updatedTitle);
        }

        nextConflict = bumpedPriority;
      }
    },
    getOverlappingEvents(calendarApi, start, end, selfId) {
      const newStart = new Date(start).getTime();
      const newEnd = new Date(end).getTime();
      const events = calendarApi.getEvents();

      const results = [];
      for (let i = 0; i < events.length; i++) {
        const evt = events[i];
        if (String(evt.id) === String(selfId)) continue;

        const evtStart = new Date(evt.start).getTime();
        const evtEnd = new Date(evt.end).getTime();
        if (newStart < evtEnd && newEnd > evtStart) {
          results.push(evt);
        }
      }

      return results;
    },
    buildPriorityList(overlappingEvents, editedSlot) {
      const list = [];

      for (let i = 0; i < overlappingEvents.length; i++) {
        const evt = overlappingEvents[i];

        let priority = 9999;
        if (
          evt.extendedProps &&
          evt.extendedProps.slotInfo &&
          typeof evt.extendedProps.slotInfo.priority === 'number'
        ) {
          priority = evt.extendedProps.slotInfo.priority;
        }

        list.push({
          evt: evt,
          priority: priority,
          isEditedSlot: false
        });
      }

      // Add the edited slot
      const editedPriority = typeof editedSlot.priority === 'number'
        ? editedSlot.priority
        : 9999;

      list.push({
        evt: editedSlot,
        priority: editedPriority,
        isEditedSlot: true
      });

      // Sort after all items are in
      list.sort(function(a, b) {
        return a.priority - b.priority;
      });

      return list;
    },
    createTimeSlot(selectInfo) {
      this.resetSlotDrawerState()
      this.selectedSlot = {
        start: selectInfo.start,
        end: selectInfo.end,
        start_reference: selectInfo.start,
        end_reference: selectInfo.end,
        status: {id: 0, name: 'Available', label: 'available'},
        min_booking_period: {id: 1, label: 'hour(s)'},
        min_booking_value: 1,
        hide_past_min_notice: 0,
        request_past_min_notice: 0,
        max_booking_period: {id: 2, label: 'month(s)'},
        max_booking_value: 6,
        slot_text: '',
        custom_message: '',
        custom_message_display: 'text',
        custom_message_active: false,
        is_all_day: false,
        all_day_text: 'All day',
        has_external_link: false,
        external_link: '',
        editing: false,
        id: uuidv4(),
        start_day: _.find(this.days_of_week, {id: selectInfo.start.getDay()}),
        end_day: _.find(this.days_of_week, {id: selectInfo.end.getDay()}),
        resource_count: 1,
        block_status: this.schedule.block_status,
        enable_autoblock: Boolean(this.schedule.enable_autoblock),
        is_custom_pricing_enabled: false,
        pricing_type: {id: 1},
        cumulative_category_pricing: true,
        hide_pricing_rate: false,
        limit_purchase_category: false,
        allow_deposit: false,
        deposit_type: {id: 1},
        deposit_amount: 1,
        require_deposit: false,
        is_public_booking: {id: 0},
        pricing_categories: [{
          category: 'Person',
          minimum_participants: 0,
          maximum_participants: null,
          default_participants: 0,
          pricing: [{min_players: 1, max_players: 2, price: 0}]
        }],
        anonymous_resource: true,
        label: 'Anonymous',
        company_user_id: null,
        email: null,
        supported_event_count: 1,
        apply_to_all_events: true,
        include_start_end_time_in_blocking: false,
        linked_games: [],
        priority: 1,
        resource_category_id: null,
        enable_auto_unblock: Boolean(this.schedule.enable_auto_unblock),
        exclude_call_to_book_from_auto_unblock: Boolean(this.schedule.exclude_call_to_book_from_auto_unblock)
      }

      this.errs.start_date_slot = ''
      this.errs.end_date_slot = ''

      this.is_all_day = false;
      this.all_day_text = 'All day';

      this.modals.create_slot = true
      let calendarApi = this.$refs.calendar.getApi();
      let overlapCount = this.countOverlappingEvents(
        calendarApi,
        this.selectedSlot.start,
        this.selectedSlot.end
      );

      this.priorities = []
      for(let i = 0; i <= overlapCount; i++){
        this.priorities.push(1+i)
      }
      this.selectedSlot.priority = this.priorities[this.priorities.length - 1]

    },
    validateDateRange(){
      let errors = 0
      if(this.schedule.duration_type.id !== 1){
        if(this.schedule.start_date > this.schedule.end_date){
          this.errs.start_date = 'Start time cannot be greater than end time'
          errors ++
        } else {
          this.errs.start_date = ''
        }
        this.errs.end_date = ''
      }
      return errors
    },
    validateResourceCount(){
      if(isNaN(this.schedule.resource_count) || this.schedule.resource_count < 0){
        this.schedule.resource_count = 1
      }
      else if(this.schedule.resource_count > 100){
        this.schedule.resource_count = 100
      }
    },
    cancelEditSchedule(){
      this.$router.push(this.schedulesLink)
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async getGames () {
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.loading = true
      this.axios.get(url, config)
        .then(response => {
          this.games = response.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    async getSchedule(){
      let calendarApi = this.$refs.calendar.getApi();
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let scheduleId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules/' + scheduleId
      this.$refs.calendar.getApi().removeAllEvents();
      this.axios.get(url, config)
        .then(response => {
          this.schedule = { ...defaultSchedule(), ...response.data.schedule }
          this.schedule.allow_late_booking = Boolean(this.schedule.allow_late_booking)
          this.schedule_name = this.schedule.name
          this.schedule.type = _.find(this.schedule_types, { id: this.schedule.type })
          this.getGames()
          if(this.schedule.type.id === 0){

            this.duration_types = [
              {
                id: 1,
                label: 'Recurring',
              },
              {
                id: 0,
                label: 'Between selected dates',
              },
              {
                id: 2,
                label: 'Closed period',
              }
            ]
          } else if(this.schedule.type.id === 1){
            this.duration_types = [
              {
                id: 1,
                label: 'Recurring',
              },
              {
                id: 0,
                label: 'Between selected dates',
              }
            ]
          }
          this.schedule.resource_count = 1
          this.schedule.enable_autoblock = true
          this.schedule.block_status = {id: 1, name: 'Blocked', label: 'blocked'}
          this.schedule.gap_duration = 30
          this.schedule.slot_duration = 60
          this.schedule.status = _.find(this.booking_statuses, { id: 0 })
          this.schedule.min_booking_period = {id: 1, label: 'hour(s)'}
          this.schedule.min_booking_value = 1
          this.schedule.max_booking_period = {id: 2, label: 'month(s)'}
          this.schedule.max_booking_value = 6
          this.schedule.external_link = ''
          this.schedule.slot_text = ''
          this.schedule.has_external_link = false
          this.$set(this.schedule, 'custom_message', '')
          this.$set(this.schedule, 'custom_message_display', 'text')
          this.$set(this.schedule, 'custom_message_active', false)
          this.schedule.apply_to_all_events = true
          this.schedule.include_start_end_time_in_blocking = false
          this.start_time = new Date()
          this.start_time.setHours(10, 0)
          this.end_time = new Date()
          this.end_time.setHours(21, 0)
          this.schedule.duration_type = _.find(this.duration_types, { id: this.schedule.is_recurring })
          this.schedule.games = response.data.games

          let slots = response.data.slots
          let today = new Date()
          let day = today.getDay()

          let day_diff = 0
          let start_date = new Date()
          let end_date = new Date()
          let event = {}
          let selectedSlot = {}
          // FullCalendar renders synchronously on every addEvent; pause rendering
          // for the whole loop so a dense schedule renders once, not once per slot.
          calendarApi.batchRendering(() => {
          for (let n in slots) {
            start_date = new Date()
            end_date = new Date()
            if(day === 0){
              start_date.setDate(start_date.getDate() - 7)
              end_date.setDate(end_date.getDate() - 7)
            }

            day_diff = day - slots[n].start_day
            start_date.setDate(start_date.getDate() - day_diff)
            start_date.setHours(slots[n].start_time.split(':')[0])
            start_date.setMinutes(slots[n].start_time.split(':')[1])
            if(start_date.getDay() === 0){
              start_date.setDate(start_date.getDate() + 7)
            }

            day_diff = day - slots[n].end_day
            end_date.setDate(end_date.getDate() - day_diff)
            end_date.setHours(slots[n].end_time.split(':')[0])
            end_date.setMinutes(slots[n].end_time.split(':')[1])
            if(end_date.getDay() === 0){
              end_date.setDate(end_date.getDate() + 7)
            }

            let status = _.find(this.booking_statuses, { label: slots[n].status })
            if(this.schedule.type.id === 1){
              status = _.find(this.resource_statuses, { label: slots[n].status })
            }

            selectedSlot = {
              start: start_date,
              end:  end_date,
              start_reference: start_date,
              end_reference:  end_date,
              status: status,
              min_booking_period: _.find(this.min_periods, { id: slots[n].min_booking_period }),
              min_booking_value: slots[n].min_booking_value,
              hide_past_min_notice: slots[n].hide_past_min_notice,
              request_past_min_notice: slots[n].request_past_min_notice,
              allow_late_booking: Boolean(slots[n].allow_late_booking),
              max_booking_period: _.find(this.max_periods, { id: slots[n].max_booking_period }),
              max_booking_value: slots[n].max_booking_value,
              slot_text: slots[n].slot_text,
              custom_message: slots[n].custom_message || '',
              custom_message_display: slots[n].custom_message_display || 'text',
              custom_message_active: (slots[n].custom_message || '').trim() ? Boolean(slots[n].custom_message_active) : false,
              has_external_link: slots[n].has_external_link,
              external_link: slots[n].external_link,
              editing: false,
              id: slots[n].id,
              is_public_booking: {id: slots[n].is_public_booking},
              start_day: _.find(this.days_of_week, {id: start_date.getDay()}),
              end_day: _.find(this.days_of_week, {id: end_date.getDay()}),
              resource_count: slots[n].resource_count,
              block_status: _.find(this.block_statuses, { label:slots[n].block_status }),
              enable_autoblock: Boolean(slots[n].enable_autoblock),
              enable_auto_unblock: Boolean(slots[n].enable_auto_unblock),
              exclude_call_to_book_from_auto_unblock: Boolean(slots[n].exclude_call_to_book_from_auto_unblock),
              saturate_on_first_assignment: Boolean(slots[n].saturate_on_first_assignment),
              supported_event_count: slots[n].supported_event_count,
              is_custom_pricing_enabled: slots[n].is_custom_pricing_enabled,
              pricing_type: _.find(this.pricing_types, { id: slots[n].pricing_type_id }),
              cumulative_category_pricing: slots[n].cumulative_category_pricing,
              hide_pricing_rate: slots[n].hide_pricing_rate,
              limit_purchase_category: slots[n].limit_purchase_category,
              allow_deposit: slots[n].allow_deposit,
              deposit_type: _.find(this.valueTypes, { id: slots[n].deposit_type }),
              deposit_amount:  slots[n].deposit_amount,
              require_deposit: slots[n].require_deposit,
              ...this.hydrateSlotPricing(slots[n]),
              anonymous_resource: Boolean(slots[n].anonymous_resource),
              label: slots[n].label,
              company_user_id: slots[n].company_user_id,
              first_name: slots[n].first_name,
              last_name: slots[n].last_name,
              email: slots[n].email,
              is_all_day: Boolean(slots[n].is_all_day),
              all_day_text: slots[n].all_day_text || 'All day',
              staff_error: '',
              label_error: '',
              apply_to_all_events: Boolean(slots[n].apply_to_all_events),
              include_start_end_time_in_blocking: Boolean(slots[n].include_start_end_time_in_blocking),
              linked_games: JSON.parse(slots[n].linked_games),
              priority: slots[n].priority,
              resource_category_id: slots[n].resource_category_id
            }

            event = {
              id: slots[n].id,
              title: this.schedule.type.id === 0 ? status.name :
                  slots[n].company_user_id ?  slots[n].first_name + ' ' +  slots[n].last_name + ' (' + slots[n].priority + ')':
                    selectedSlot.label + ' (' + slots[n].priority + ')',
              start: start_date,
              end:  end_date,
              allDay: slots[n].is_all_day,
              backgroundColor: "#1d8cf8",
              slotInfo: selectedSlot
            }
            if(slots[n].status === 'blocked' || slots[n].status === 'unavailable'){
              event.backgroundColor = "#fd5d93"
            }
            if(slots[n].status === 'call_to_book'){
              event.backgroundColor = "#ff8d72"
            }
            if(slots[n].status === 'requestable'){
              event.backgroundColor = "#FFD600"
              event.textColor = "#1E1E2F"
            }
            calendarApi.addEvent(event);
          }
          })

          this.loading = false
          if(slots.length > 0){
            this.expandTimeLineRange(event.start, event.end)
            this.updateAllDaySlotVisibility();
          }

        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    validateScheduleFields(){
      let errors = 0
      if(this.schedule.name == '') {
        this.errs.name = 'Schedule name cannot be empty'
        errors++
      } else {
        this.errs.name = ''
      }

      if(this.schedule.duration_type.id !== 1 && !this.schedule.start_date){
        this.errs.start_date = 'Start date cannot be empty'
        errors++
      } else {
        this.errs.start_date = ''
      }

      // For recurring schedules, validate start date is not before today
      if(this.schedule.duration_type.id === 1 && this.schedule.start_date){
        let today = moment().startOf('day')
        let scheduleStart = moment(this.schedule.start_date).startOf('day')
        if(scheduleStart.isBefore(today)){
          this.errs.start_date = 'Start date cannot be earlier than today'
          errors++
        }
      }

      let start = moment(this.schedule.start_date)
      let end = moment(this.schedule.end_date)
      const isDateSequenceBeforeOrSame = start.isBefore(end) || start.isSame(end)
      const isClosedPeriod = this.schedule.duration_type.id === 2
      const maxEndDate = moment().add(isClosedPeriod ? 5 : 1, 'year')

      if(this.schedule.duration_type.id !== 1 && (this.schedule.end_date === '' || this.schedule.end_date === null)){
        this.errs.end_date = "End date cannot be empty"
        errors++
      } else if(this.schedule.duration_type.id !== 1 && !isDateSequenceBeforeOrSame){
        this.errs.end_date = "End date cannot be before start time"
        errors++
      } else if (this.schedule.duration_type.id !== 1 && end.isAfter(maxEndDate)) {
        this.errs.end_date = isClosedPeriod ? "End date cannot be more than five years from today" : "End date cannot be more than one year from today";
        errors++;
      } else {
        this.errs.end_date = ''
      }

      // Validate slots with custom pricing have at least one pricing category
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      for(let n in events){
        let slot = events[n]._def.extendedProps.slotInfo
        if(slot && slot.is_custom_pricing_enabled && (!slot.pricing_categories || slot.pricing_categories.length === 0)){
          this.showDialog({ variant: 'danger', title: 'Error', message: 'One or more time slots have custom pricing enabled but no pricing categories. Please add at least one pricing category or disable custom pricing.' })
          errors++
          break
        }
        if(slot && slot.is_custom_pricing_enabled && slot.pricing_categories.some(c => c.minimum_participants === null || c.minimum_participants === undefined)){
          this.showDialog({ variant: 'danger', title: 'Error', message: 'One or more pricing categories have an empty minimum required value. Please enter a minimum for each category (0 for no minimum).' })
          errors++
          break
        }
      }

      if(errors > 0){
        this.$nextTick(() => {
          let errorEl = document.querySelector('.has-danger')
          if(errorEl){
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }

      return errors
    },
    async updateSchedule(){
      if(this.validateScheduleFields()){
        return
      }
      let calendarApi = this.$refs.calendar.getApi();
      let events = calendarApi.getEvents();
      let slots = []
      let slot = {}
      for(let n in events){
        slot = events[n]._def.extendedProps.slotInfo
        let start = slot.start.getHours() + ':' + slot.start.getMinutes()
        let end = slot.end.getHours() + ':' + slot.end.getMinutes()

        // slot.start_time = slot.start_time.split('T')[1].split(':')[0] + ':' + slot.start_time.split('T')[1].split(':')[1]
        // slot.end_time = slot.end_time.split('T')[1].split(':')[0] + ':' + slot.end_time.split('T')[1].split(':')[1]
        slots.push({
          start: start,
          end: end,
          start_day: slot.start_day.id,
          end_day: slot.end_day.id,
          status: slot.status,
          min_booking_period: slot.min_booking_period,
          min_booking_value: slot.min_booking_value,
          hide_past_min_notice: slot.hide_past_min_notice,
          request_past_min_notice: slot.request_past_min_notice,
          allow_late_booking: slot.allow_late_booking,
          max_booking_period: slot.max_booking_period,
          max_booking_value: slot.max_booking_value,
          slot_text: slot.slot_text,
          custom_message: slot.custom_message || '',
          custom_message_display: slot.custom_message_display || 'text',
          custom_message_active: slot.custom_message_active ? 1 : 0,
          has_external_link: slot.has_external_link,
          external_link: slot.external_link,
          is_all_day: Boolean(slot.is_all_day),
          all_day_text: slot.all_day_text,
          editing: false,
          id: slot.id,
          resource_count: slot.resource_count,
          enable_autoblock: Boolean(slot.enable_autoblock),
          enable_auto_unblock: Boolean(slot.enable_auto_unblock),
          exclude_call_to_book_from_auto_unblock: Boolean(slot.exclude_call_to_book_from_auto_unblock),
          saturate_on_first_assignment: Boolean(slot.saturate_on_first_assignment),
          block_status: slot.block_status,
          is_public_booking: slot.is_public_booking.id,
          is_custom_pricing_enabled: slot.is_custom_pricing_enabled,
          pricing_type: slot.pricing_type.id,
          cumulative_category_pricing: slot.cumulative_category_pricing,
          hide_pricing_rate: slot.hide_pricing_rate,
          limit_purchase_category: slot.limit_purchase_category,
          allow_deposit: slot.allow_deposit,
          deposit_type: slot.deposit_type.id,
          deposit_amount: slot.deposit_amount,
          require_deposit: slot.require_deposit,
          custom_pricing: flattenCategoriesByDuration(slot.pricing_categories || [], slot.is_custom_pricing_enabled && slot.enable_multiple_durations ? (slot.durations || []) : []).map(c => ({ ...c, minimum_participants: c.minimum_participants ?? 0 })),
          enable_multiple_durations: slot.is_custom_pricing_enabled && slot.enable_multiple_durations ? 1 : 0,
          durations: slot.is_custom_pricing_enabled && slot.enable_multiple_durations ? (slot.durations || []).map(d => ({ duration_minutes: Number(d.duration_minutes), is_default: d.is_default ? 1 : 0, position: Number(d.position) || 0 })) : [],
          label: slot.label,
          company_user_id: slot.resource_assignee_object && !slot.anonymous_resource ? slot.resource_assignee_object.id : slot.company_user_id,
          supported_event_count: slot.supported_event_count,
          include_start_end_time_in_blocking: slot.include_start_end_time_in_blocking,
          apply_to_all_events: slot.apply_to_all_events,
          linked_games: slot.linked_games,
          priority: slot.priority,
          resource_category_id: slot.resource_category_id
        })
      }
      let time = new Date()
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let scheduleId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules/' + scheduleId
      let data = {
        schedule: this.schedule,
        slots: slots,
        ...buildFutureSlotFlags(this.future_slots),
        time: time.getFullYear() + '-' + (time.getMonth()+1) + '-' + time.getDate(),
      }
      data.schedule.start_date = moment(data.schedule.start_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
      data.schedule.end_date = moment(data.schedule.end_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
      this.loading = true
      this.axios.put(url, data, config)
        .then(response => {
          this.modals.future_slots = false
          this.$notify({ type: 'success', message: 'Schedule has been updated.', icon: 'tim-icons icon-check-2' })
          const scheduleType = this.$route.query.type
          this.$router.push({ path: '/bookings/schedules', query: { tab: scheduleType }})
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          }
        })

    },
  },
  mounted() {
    this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
    this.date_format_cal = this.date_format
    this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
    this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
    if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
      this.day_of_week = 'ddd, '
    }
    if (this.time_format === 'HH:mm') {
      this.picker_time_format = 'HH:mm'
    }
    this.getSchedule()
    this.startStatusPolling()
  }
}
</script>

<style scoped>
.toggle-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}
.toggle-row label {
  font-size: 13px;
}
.restore-scope {
  padding-left: 3rem;
  margin-top: -0.25rem;
  margin-bottom: 1.5rem;
}
.restore-label {
  font-size: 13px;
  margin-bottom: 0.25rem;
}
</style>

